// // progress bar
// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
//   useCallback,
//   useMemo,
// } from "react";
// import useRecent from "../hooks/useRecent";
// import { useAuth } from "./AuthContext";
// import { supabase } from "../supabaseClient";
// import { cacheTrack } from "../utils/cacheTrack";
// import { getTrack } from "../utils/offlineCache";

// const AudioContext = createContext(null);

// // --- NEW: YouTube IFrame API loader -----------------------------------
// // Loads the YouTube IFrame API script once and resolves with window.YT
// // when it's ready. Safe to call multiple times; only loads the script once.
// function loadYouTubeIframeAPI() {
//   return new Promise((resolve) => {
//     if (window.YT && window.YT.Player) {
//       resolve(window.YT);
//       return;
//     }
//     const existingCallback = window.onYouTubeIframeAPIReady;
//     window.onYouTubeIframeAPIReady = () => {
//       if (existingCallback) existingCallback();
//       resolve(window.YT);
//     };
//     if (!document.getElementById("youtube-iframe-api-script")) {
//       const tag = document.createElement("script");
//       tag.id = "youtube-iframe-api-script";
//       tag.src = "https://www.youtube.com/iframe_api";
//       document.body.appendChild(tag);
//     }
//   });
// }
// // ------------------------------------------------------------------------

// export function AudioProvider({ children }) {
//   const { user } = useAuth();
//   const STORAGE_KEY = user ? `audio_state_${user.id}` : null;
//   const audioRef = useRef(new Audio());
//   const loadRequestRef = useRef(0);
//   const { addRecent } = useRecent();
//   const [resumeTime, setResumeTime] = useState(0);

//   // Player states
//   const [queue, setQueue] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(-1);
//   const [playing, setPlaying] = useState(false);
//   const [loopOne, setLoopOne] = useState(false);
//   const [shuffle, setShuffle] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);

//   // NEW: States for shuffle order (prevents repeats within one loop)
//   const [shuffleOrder, setShuffleOrder] = useState([]);
//   const [shufflePointer, setShufflePointer] = useState(0);

//   // --- NEW: YouTube player refs -----------------------------------------
//   const ytPlayerRef = useRef(null);
//   const ytReadyPromiseRef = useRef(null);
//   const loopOneRef = useRef(loopOne);
//   const playNextRef = useRef(() => {});
//   // ------------------------------------------------------------------------

//   const saveProgress = async (trackId, position, duration) => {
//     if (!user || !trackId) return;
//     if (position < 5) return;

//     await supabase.from("continue_listening").upsert(
//       {
//         user_id: user.id,
//         track_id: trackId,
//         last_position: Math.floor(position),
//         duration: Math.floor(duration || 0),
//         updated_at: new Date(),
//       },
//       {
//         onConflict: "user_id,track_id",
//       },
//     );
//   };

//   const currentTrack =
//     currentIndex >= 0 && currentIndex < queue.length
//       ? queue[currentIndex]
//       : null;

//   // NEW: is the currently loaded track a YouTube-sourced track?
//   const isYoutubeTrack = !!currentTrack?.youtube_video_id;

//   // NEW: unified getters so progress-saving / UI code doesn't need to
//   // know which underlying player is active.
//   const getPlaybackTime = useCallback(() => {
//     if (isYoutubeTrack && ytPlayerRef.current?.getCurrentTime) {
//       return ytPlayerRef.current.getCurrentTime() || 0;
//     }
//     return audioRef.current.currentTime || 0;
//   }, [isYoutubeTrack]);

//   const getPlaybackDuration = useCallback(() => {
//     if (isYoutubeTrack && ytPlayerRef.current?.getDuration) {
//       return ytPlayerRef.current.getDuration() || 0;
//     }
//     return audioRef.current.duration || 0;
//   }, [isYoutubeTrack]);

//   // NEW: Fisher-Yates shuffle helper - creates one full order without repeats
//   const buildShuffleOrder = useCallback((tracks, startIndex = 0) => {
//     if (!tracks?.length) return { order: [], pointer: 0 };

//     const indices = tracks.map((_, i) => i);
//     const remaining = indices.filter((i) => i !== startIndex);

//     // Fisher-Yates shuffle
//     for (let i = remaining.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
//     }

//     const order = [startIndex, ...remaining];
//     return { order, pointer: 0 };
//   }, []);

//   // --- NEW: keep refs in sync so the YT event handler (created once on
//   // mount) always sees the latest loopOne / playNext without re-creating
//   // the player. -------------------------------------------------------
//   useEffect(() => {
//     loopOneRef.current = loopOne;
//   }, [loopOne]);

//   // --- NEW: create the hidden YouTube player once on mount --------------
//   // IMPORTANT: the container div is created with plain DOM APIs and
//   // appended directly to document.body, OUTSIDE of React's rendering.
//   // The YouTube IFrame API replaces this div with a real <iframe> internally;
//   // if React also tried to render/reconcile this same node, the two would
//   // fight over it and throw "insertBefore" / "not a child of this node"
//   // errors. Keeping it fully outside JSX avoids that entirely.
//   useEffect(() => {
//     const container = document.createElement("div");
//     container.id = "yt-audio-player-container";
//     container.style.position = "absolute";
//     container.style.top = "-9999px";
//     container.style.left = "-9999px";
//     // 200x200 rather than 0x0/1x1 -- very small player sizes are known to
//     // cause flaky internal behavior (duration/quality calc glitches) in
//     // the YouTube IFrame API.
//     container.style.width = "200px";
//     container.style.height = "200px";
//     document.body.appendChild(container);

//     ytReadyPromiseRef.current = new Promise((resolve) => {
//       loadYouTubeIframeAPI().then((YT) => {
//         const player = new YT.Player(container, {
//           height: "200",
//           width: "200",
//           playerVars: { controls: 0, disablekb: 1 },
//           events: {
//             onReady: () => {
//               ytPlayerRef.current = player;
//               resolve(player);
//             },
//             onStateChange: (event) => {
//               if (event.data === window.YT.PlayerState.ENDED) {
//                 if (loopOneRef.current) {
//                   player.seekTo(0, true);
//                   player.playVideo();
//                 } else {
//                   playNextRef.current();
//                 }
//               }
//             },
//           },
//         });
//       });
//     });

//     return () => {
//       if (ytPlayerRef.current?.destroy) {
//         try {
//           ytPlayerRef.current.destroy();
//         } catch {
//           // ignore
//         }
//       }
//       if (container.parentNode) {
//         container.parentNode.removeChild(container);
//       }
//     };
//   }, []);
//   // ------------------------------------------------------------------------

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

//     if (!saved) return;

//     const {
//       queue,
//       currentIndex,
//       currentTime,
//       wasPlaying,
//       loopOne,
//       shuffle,
//       shuffleOrder,
//       shufflePointer,
//     } = saved;

//     if (!queue?.length) return;

//     setQueue(queue);
//     setCurrentIndex(currentIndex);
//     setLoopOne(loopOne);
//     setShuffle(!!shuffle);
//     setShuffleOrder(shuffleOrder || []);
//     setShufflePointer(shufflePointer || 0);

//     const audio = audioRef.current;

//     setTimeout(() => {
//       // NEW: only resume native audio's currentTime here; YouTube tracks
//       // resume via resumeTime in the loadTrack effect below instead,
//       // since the YT player may not be ready yet at this point.
//       const track = queue[currentIndex];
//       if (track && !track.youtube_video_id) {
//         audio.currentTime = currentTime || 0;

//         if (wasPlaying) {
//           audio.play().catch(() => {});
//           setPlaying(true);
//         }
//       } else if (track && wasPlaying) {
//         setPlaying(true);
//       }
//     }, 0);
//   }, [STORAGE_KEY]);

//   useEffect(() => {
//     if (!currentTrack) return;

//     const interval = setInterval(() => {
//       // CHANGED: use the unified getter instead of reading audioRef directly,
//       // so progress saves correctly for YouTube tracks too.
//       const isPlayingNow = isYoutubeTrack
//         ? ytPlayerRef.current?.getPlayerState?.() ===
//           window.YT?.PlayerState?.PLAYING
//         : !audioRef.current.paused;

//       if (isPlayingNow) {
//         saveProgress(currentTrack.id, getPlaybackTime(), getPlaybackDuration());
//       }
//     }, 10000);

//     return () => {
//       clearInterval(interval);

//       if (currentTrack) {
//         saveProgress(currentTrack.id, getPlaybackTime(), getPlaybackDuration());
//       }
//     };
//   }, [currentTrack, user, isYoutubeTrack]);

//   // FIXED: setNewQueue now also builds shuffle order if shuffle is on
//   const setNewQueue = useCallback(
//     (tracks, index) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setCurrentIndex(index);

//       if (shuffle) {
//         const { order, pointer } = buildShuffleOrder(tracks, index);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//       } else {
//         setShuffleOrder([]);
//         setShufflePointer(0);
//       }
//     },
//     [shuffle, buildShuffleOrder],
//   );

//   // FIXED: playAll always uses original order, no shuffle
//   const playAll = useCallback((tracks) => {
//     if (!tracks?.length) return;

//     setQueue(tracks);
//     setCurrentIndex(0);
//     setShuffle(false);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//   }, []);

//   const shufflePlay = useCallback(
//     (tracks) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setShuffle(true);

//       const startIndex = Math.floor(Math.random() * tracks.length);

//       const { order, pointer } = buildShuffleOrder(tracks, startIndex);

//       setShuffleOrder(order);
//       setShufflePointer(pointer);

//       setCurrentIndex(order[pointer]);
//     },
//     [buildShuffleOrder],
//   );

//   const addToQueue = useCallback((track) => {
//     if (!track) return;

//     setQueue((prev) => {
//       if (prev.some((t) => t.id === track.id)) return prev;
//       return [...prev, track];
//     });
//   }, []);

//   const playNextInsert = useCallback(
//     (track) => {
//       if (!track) return;

//       setQueue((prev) => {
//         if (!prev.length) {
//           setCurrentIndex(0);
//           return [track];
//         }

//         const newQueue = [...prev];
//         newQueue.splice(currentIndex + 1, 0, track);
//         return newQueue;
//       });
//     },
//     [currentIndex],
//   );

//   // CHANGED: togglePlay now branches on source type
//   const togglePlay = useCallback(() => {
//     if (isYoutubeTrack) {
//       const yt = ytPlayerRef.current;
//       if (!yt || !window.YT) return;

//       const state = yt.getPlayerState();
//       if (state === window.YT.PlayerState.PLAYING) {
//         yt.pauseVideo();
//         setPlaying(false);
//       } else {
//         yt.playVideo();
//         setPlaying(true);
//       }
//       return;
//     }

//     const audio = audioRef.current;
//     if (!audio.src) return;

//     if (audio.paused) {
//       audio.play().then(() => setPlaying(true));
//     } else {
//       audio.pause();
//       setPlaying(false);
//     }
//   }, [isYoutubeTrack]);

//   // FIXED: playNext no longer picks random song, uses pre-built shuffle order
//   const playNext = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         // If no shuffle order exists yet, create one
//         if (!shuffleOrder.length) {
//           const { order, pointer } = buildShuffleOrder(
//             queue,
//             current >= 0 ? current : 0,
//           );
//           setShuffleOrder(order);
//           setShufflePointer(pointer);
//           return order[pointer];
//         }

//         const nextPointer = shufflePointer + 1;

//         // If we haven't finished the loop yet, go to next song in shuffle order
//         if (nextPointer < shuffleOrder.length) {
//           setShufflePointer(nextPointer);
//           return shuffleOrder[nextPointer];
//         }

//         // If we finished the loop, create a fresh shuffle order for the next cycle
//         let nextStart = Math.floor(Math.random() * queue.length);

//         // avoid immediate repeat of the just-finished last song
//         const lastPlayed = shuffleOrder[shuffleOrder.length - 1];
//         if (queue.length > 1) {
//           while (nextStart === lastPlayed) {
//             nextStart = Math.floor(Math.random() * queue.length);
//           }
//         }

//         const { order, pointer } = buildShuffleOrder(queue, nextStart);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//         return order[pointer];
//       }

//       // Normal mode: go to next, and wrap to 0 at the end
//       if (current + 1 < queue.length) {
//         return current + 1;
//       }

//       return 0;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer, buildShuffleOrder]);

//   // NEW: keep a ref to the latest playNext for the YT onStateChange handler
//   useEffect(() => {
//     playNextRef.current = playNext;
//   }, [playNext]);

//   // FIXED: playPrev also uses shuffle order when shuffle is on
//   const playPrev = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         if (!shuffleOrder.length) return current;

//         const prevPointer = shufflePointer - 1;

//         if (prevPointer >= 0) {
//           setShufflePointer(prevPointer);
//           return shuffleOrder[prevPointer];
//         }

//         return shuffleOrder[0];
//       }

//       // Normal mode: go to previous, wrap to last song at beginning
//       return current > 0 ? current - 1 : queue.length - 1;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer]);

//   const reorderQueue = useCallback((newQueue) => {
//     setQueue(newQueue);
//   }, []);

//   const removeFromQueue = useCallback(
//     (trackId) => {
//       setQueue((prev) => {
//         const updated = prev.filter((t) => t.id !== trackId);

//         const removedIndex = prev.findIndex((t) => t.id === trackId);

//         if (removedIndex < currentIndex) {
//           setCurrentIndex((i) => i - 1);
//         }

//         return updated;
//       });
//     },
//     [currentIndex],
//   );

//   // FIXED: clearQueue also clears shuffle states
//   const clearQueue = useCallback(() => {
//     setQueue([]);
//     setCurrentIndex(-1);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//     audioRef.current.pause();
//     audioRef.current.src = "";
//     // NEW: stop YouTube playback too, if a YT track was playing
//     if (ytPlayerRef.current?.stopVideo) {
//       try {
//         ytPlayerRef.current.stopVideo();
//       } catch {
//         // player may not be ready; safe to ignore
//       }
//     }
//     setPlaying(false);
//   }, []);

  
//   // useEffect(() => {
//   //   const loadTrack = async () => {
//   //     if (!currentTrack) return;

//   //     // --- NEW: YouTube-sourced track path ---------------------------
//   //     if (currentTrack.youtube_video_id) {
//   //       // Make sure native audio isn't also playing underneath
//   //       audioRef.current.pause();

//   //       const yt = ytPlayerRef.current || (await ytReadyPromiseRef.current);
//   //       if (!yt) return;

//   //       yt.loadVideoById(currentTrack.youtube_video_id);
//   //       setPlaying(true);
//   //       addRecent(currentTrack);
//   //       // Deliberately no cacheTrack()/offline caching for YouTube tracks.

//   //       if (resumeTime > 0) {
//   //         // give the player a moment to actually load before seeking
//   //         setTimeout(() => {
//   //           try {
//   //             yt.seekTo(resumeTime, true);
//   //           } catch {
//   //             // ignore if not ready yet
//   //           }
//   //         }, 500);
//   //         setResumeTime(0);
//   //       }

//   //       saveProgress(currentTrack.id, 0, 0);
//   //       return;
//   //     }
//   //     // ------------------------------------------------------------------

//   //     // ---- existing native-audio logic (unchanged) ----
//   //     const audio = audioRef.current;

//   //     // NEW: stop any YouTube playback first, in case the previous track was one
//   //     if (ytPlayerRef.current?.stopVideo) {
//   //       try {
//   //         ytPlayerRef.current.stopVideo();
//   //       } catch {
//   //         // ignore
//   //       }
//   //     }

//   //     try {
//   //       const cachedBlob = await getTrack(currentTrack.id);

//   //       if (cachedBlob) {
//   //         const blobUrl = URL.createObjectURL(cachedBlob);
//   //         audio.src = blobUrl;
//   //       } else {
//   //         audio.src =
//   //           currentTrack.external_url || currentTrack.storage_path || "";
//   //       }

//   //       await audio.play();

//   //       setPlaying(true);

//   //       addRecent(currentTrack);

//   //       cacheTrack(currentTrack);

//   //       if (resumeTime > 0) {
//   //         audio.currentTime = resumeTime;
//   //         setResumeTime(0);
//   //       }

//   //       saveProgress(currentTrack.id, 0, audio.duration);
//   //     } catch (err) {
//   //       if (err.name === "AbortError") {
//   //         return;
//   //       }

//   //       console.error(err);
//   //       setPlaying(false);
//   //     }
//   //   };

//   //   loadTrack();
//   // }, [currentTrack]);


// useEffect(() => {
//   const requestId = ++loadRequestRef.current;
//   let cancelled = false;

//   const isCurrentRequest = () =>
//     !cancelled && loadRequestRef.current === requestId;

//   const loadTrack = async () => {
//     if (!currentTrack) return;

//     const audio = audioRef.current;

//     // Stop the previous native track before loading another one.
//     audio.pause();

//     // YouTube branch: preserve the existing support.
//     if (currentTrack.youtube_video_id) {
//       try {
//         const yt =
//           ytPlayerRef.current || (await ytReadyPromiseRef.current);

//         if (!isCurrentRequest() || !yt) return;

//         yt.loadVideoById(currentTrack.youtube_video_id);

//         if (!isCurrentRequest()) return;

//         setPlaying(true);
//         addRecent(currentTrack);

//         if (resumeTime > 0) {
//           const timeToResume = resumeTime;
//           setResumeTime(0);

//           setTimeout(() => {
//             if (!isCurrentRequest()) return;

//             try {
//               yt.seekTo(timeToResume, true);
//             } catch (err) {
//               console.warn("Unable to restore playback position:", err);
//             }
//           }, 500);
//         }

//         saveProgress(currentTrack.id, 0, 0);
//       } catch (err) {
//         if (!isCurrentRequest()) return;

//         console.error("Unable to load YouTube track:", err);
//         setPlaying(false);
//       }

//       return;
//     }

//     // Native audio: cache lookup can finish asynchronously.
//     try {
//       if (ytPlayerRef.current?.stopVideo) {
//         try {
//           ytPlayerRef.current.stopVideo();
//         } catch {
//           // Ignore an unavailable YouTube player.
//         }
//       }

//       const cachedBlob = await getTrack(currentTrack.id);

//       // Never let an older request replace the newly selected track.
//       if (!isCurrentRequest()) return;

//       if (cachedBlob) {
//         audio.src = URL.createObjectURL(cachedBlob);
//       } else {
//         audio.src =
//           currentTrack.external_url ||
//           currentTrack.storage_path ||
//           "";
//       }

//       if (!audio.src) {
//         throw new Error("No playable audio source found.");
//       }

//       audio.load();

//       await audio.play();

//       // The selected track may have changed while play() was pending.
//       if (!isCurrentRequest()) return;

//       setPlaying(true);
//       addRecent(currentTrack);
//       cacheTrack(currentTrack);

//       if (resumeTime > 0) {
//         const timeToResume = resumeTime;
//         setResumeTime(0);

//         // Wait until metadata is available before seeking.
//         if (audio.readyState >= 1) {
//           audio.currentTime = timeToResume;
//         } else {
//           const onMetadata = () => {
//             if (isCurrentRequest()) {
//               audio.currentTime = Math.min(
//                 timeToResume,
//                 audio.duration || timeToResume,
//               );
//             }
//           };

//           audio.addEventListener("loadedmetadata", onMetadata, {
//             once: true,
//           });
//         }
//       }

//       saveProgress(currentTrack.id, 0, audio.duration);
//     } catch (err) {
//       if (!isCurrentRequest()) return;
//       if (err.name === "AbortError") return;

//       console.error("Audio playback failed:", err);
//       setPlaying(false);
//     }
//   };

//   loadTrack();

//   return () => {
//     cancelled = true;
//   };
// }, [currentTrack]);



//   useEffect(() => {
//     const audio = audioRef.current;

//     const onTime = () => {
//       setCurrentTime(audio.currentTime);
//     };

//     const onLoaded = () => setDuration(audio.duration || 0);

//     const onEnded = () => {
//       if (loopOne) {
//         audio.currentTime = 0;
//         audio.play();
//       } else {
//         playNext();
//       }
//     };

//     audio.addEventListener("timeupdate", onTime);
//     audio.addEventListener("loadedmetadata", onLoaded);
//     audio.addEventListener("ended", onEnded);

//     return () => {
//       audio.removeEventListener("timeupdate", onTime);
//       audio.removeEventListener("loadedmetadata", onLoaded);
//       audio.removeEventListener("ended", onEnded);
//     };
//   }, [loopOne, shuffle, playNext]);

//   // --- NEW: poll currentTime/duration for YouTube tracks, since the
//   // IFrame API has no timeupdate event like <audio> does. ---------------
//   useEffect(() => {
//     if (!isYoutubeTrack) return;

//     const interval = setInterval(() => {
//       const yt = ytPlayerRef.current;
//       if (
//         !yt ||
//         typeof yt.getCurrentTime !== "function" ||
//         typeof yt.getDuration !== "function"
//       ) {
//         return;
//       }
//       setCurrentTime(yt.getCurrentTime() || 0);
//       setDuration(yt.getDuration() || 0);
//     }, 500);

//     return () => clearInterval(interval);
//   }, [isYoutubeTrack, currentTrack]);
//   // ------------------------------------------------------------------------

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     localStorage.setItem(
//       STORAGE_KEY,
//       JSON.stringify({
//         queue,
//         currentIndex,
//         currentTime,
//         wasPlaying: playing,
//         loopOne,
//         shuffle,
//         shuffleOrder,
//         shufflePointer,
//       }),
//     );
//   }, [
//     queue,
//     currentIndex,
//     currentTime,
//     playing,
//     loopOne,
//     shuffle,
//     shuffleOrder,
//     shufflePointer,
//     STORAGE_KEY,
//   ]);

//   // CHANGED: seekTo now branches on source type
//   const seekTo = (sec) => {
//     if (isYoutubeTrack) {
//       const yt = ytPlayerRef.current;
//       if (!yt) return;
//       yt.seekTo(Math.max(0, sec), true);
//       return;
//     }

//     const audio = audioRef.current;
//     if (!audio) return;
//     audio.currentTime = Math.max(0, Math.min(sec, audio.duration || 0));
//   };

//   const value = useMemo(
//     () => ({
//       audioRef,
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       setNewQueue,
//       setResumeTime,
//       playAll,
//       shufflePlay,
//       addToQueue,
//       playNextInsert,
//       playNext,
//       playPrev,
//       togglePlay,
//       setLoopOne,
//       setShuffle,
//       seekTo,
//       removeFromQueue,
//       clearQueue,
//       reorderQueue,
//       shuffleOrder,
//       shufflePointer,
//       isYoutubeTrack, // NEW: exposed in case UI wants to show a YouTube badge/icon
//     }),
//     [
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       shuffleOrder,
//       shufflePointer,
//       isYoutubeTrack,
//     ],
//   );

//   // NOTE: the YouTube player's container div is created and managed with
//   // plain DOM APIs in the effect above -- it is intentionally NOT rendered
//   // here via JSX, to avoid React and the YouTube IFrame API fighting over
//   // the same DOM node (see comment above).
//   return (
//     <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
//   );
// }

// export function useAudio() {
//   return useContext(AudioContext);
// }




// 
// progress bar
// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
//   useCallback,
//   useMemo,
// } from "react";
// import useRecent from "../hooks/useRecent";
// import { useAuth } from "./AuthContext";
// import { supabase } from "../supabaseClient";
// import { cacheTrack } from "../utils/cacheTrack";
// import { getTrack } from "../utils/offlineCache";

// const AudioContext = createContext(null);

// // Tracks saved from the old YouTube integration have no audio source of
// // their own. They can't be played anymore, so they are dropped when a
// // saved queue is restored from localStorage.
// const isLegacyYoutubeOnly = (t) =>
//   !!t?.youtube_video_id && !t?.external_url && !t?.storage_path;

// export function AudioProvider({ children }) {
//   const { user } = useAuth();
//   const STORAGE_KEY = user ? `audio_state_${user.id}` : null;
//   const audioRef = useRef(new Audio());
//   const loadRequestRef = useRef(0);
//   const { addRecent } = useRecent();
//   const [resumeTime, setResumeTime] = useState(0);

//   // Player states
//   const [queue, setQueue] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(-1);
//   const [playing, setPlaying] = useState(false);
//   const [loopOne, setLoopOne] = useState(false);
//   const [shuffle, setShuffle] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);

//   // NEW: States for shuffle order (prevents repeats within one loop)
//   const [shuffleOrder, setShuffleOrder] = useState([]);
//   const [shufflePointer, setShufflePointer] = useState(0);

//   const saveProgress = async (trackId, position, duration) => {
//     if (!user || !trackId) return;
//     if (position < 5) return;

//     await supabase.from("continue_listening").upsert(
//       {
//         user_id: user.id,
//         track_id: trackId,
//         last_position: Math.floor(position),
//         duration: Math.floor(duration || 0),
//         updated_at: new Date(),
//       },
//       {
//         onConflict: "user_id,track_id",
//       },
//     );
//   };

//   const currentTrack =
//     currentIndex >= 0 && currentIndex < queue.length
//       ? queue[currentIndex]
//       : null;

//   // NEW: Fisher-Yates shuffle helper - creates one full order without repeats
//   const buildShuffleOrder = useCallback((tracks, startIndex = 0) => {
//     if (!tracks?.length) return { order: [], pointer: 0 };

//     const indices = tracks.map((_, i) => i);
//     const remaining = indices.filter((i) => i !== startIndex);

//     // Fisher-Yates shuffle
//     for (let i = remaining.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
//     }

//     const order = [startIndex, ...remaining];
//     return { order, pointer: 0 };
//   }, []);

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

//     if (!saved) return;

//     let {
//       queue: savedQueue,
//       currentIndex: savedIndex,
//       currentTime,
//       wasPlaying,
//       loopOne,
//       shuffle,
//       shuffleOrder,
//       shufflePointer,
//     } = saved;

//     if (!savedQueue?.length) return;

//     // Drop leftover YouTube-only tracks and remap the current index.
//     const queue = savedQueue.filter((t) => !isLegacyYoutubeOnly(t));
//     if (!queue.length) return;

//     const removedCount = savedQueue.length - queue.length;
//     let currentIndex = savedIndex;

//     if (removedCount > 0) {
//       const keptBefore = savedQueue
//         .slice(0, Math.max(savedIndex, 0))
//         .filter((t) => !isLegacyYoutubeOnly(t)).length;
//       const currentWasKept =
//         savedQueue[savedIndex] && !isLegacyYoutubeOnly(savedQueue[savedIndex]);

//       currentIndex = Math.min(keptBefore, queue.length - 1);
//       // The saved shuffle order refers to old indices, so reset it.
//       shuffleOrder = [];
//       shufflePointer = 0;
//       if (!currentWasKept) {
//         currentTime = 0;
//         wasPlaying = false;
//       }
//     }

//     setQueue(queue);
//     setCurrentIndex(currentIndex);
//     setLoopOne(loopOne);
//     setShuffle(!!shuffle);
//     setShuffleOrder(shuffleOrder || []);
//     setShufflePointer(shufflePointer || 0);

//     const audio = audioRef.current;

//     setTimeout(() => {
//       const track = queue[currentIndex];
//       if (track) {
//         audio.currentTime = currentTime || 0;

//         if (wasPlaying) {
//           audio.play().catch(() => {});
//           setPlaying(true);
//         }
//       }
//     }, 0);
//   }, [STORAGE_KEY]);

//   useEffect(() => {
//     if (!currentTrack) return;

//     const interval = setInterval(() => {
//       if (!audioRef.current.paused) {
//         saveProgress(
//           currentTrack.id,
//           audioRef.current.currentTime || 0,
//           audioRef.current.duration || 0,
//         );
//       }
//     }, 10000);

//     return () => {
//       clearInterval(interval);

//       if (currentTrack) {
//         saveProgress(
//           currentTrack.id,
//           audioRef.current.currentTime || 0,
//           audioRef.current.duration || 0,
//         );
//       }
//     };
//   }, [currentTrack, user]);

//   // FIXED: setNewQueue now also builds shuffle order if shuffle is on
//   const setNewQueue = useCallback(
//     (tracks, index) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setCurrentIndex(index);

//       if (shuffle) {
//         const { order, pointer } = buildShuffleOrder(tracks, index);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//       } else {
//         setShuffleOrder([]);
//         setShufflePointer(0);
//       }
//     },
//     [shuffle, buildShuffleOrder],
//   );

//   // FIXED: playAll always uses original order, no shuffle
//   const playAll = useCallback((tracks) => {
//     if (!tracks?.length) return;

//     setQueue(tracks);
//     setCurrentIndex(0);
//     setShuffle(false);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//   }, []);

//   const shufflePlay = useCallback(
//     (tracks) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setShuffle(true);

//       const startIndex = Math.floor(Math.random() * tracks.length);

//       const { order, pointer } = buildShuffleOrder(tracks, startIndex);

//       setShuffleOrder(order);
//       setShufflePointer(pointer);

//       setCurrentIndex(order[pointer]);
//     },
//     [buildShuffleOrder],
//   );

//   const addToQueue = useCallback((track) => {
//     if (!track) return;

//     setQueue((prev) => {
//       if (prev.some((t) => t.id === track.id)) return prev;
//       return [...prev, track];
//     });
//   }, []);

//   const playNextInsert = useCallback(
//     (track) => {
//       if (!track) return;

//       setQueue((prev) => {
//         if (!prev.length) {
//           setCurrentIndex(0);
//           return [track];
//         }

//         const newQueue = [...prev];
//         newQueue.splice(currentIndex + 1, 0, track);
//         return newQueue;
//       });
//     },
//     [currentIndex],
//   );

//   const togglePlay = useCallback(() => {
//     const audio = audioRef.current;
//     if (!audio.src) return;

//     if (audio.paused) {
//       audio.play().then(() => setPlaying(true));
//     } else {
//       audio.pause();
//       setPlaying(false);
//     }
//   }, []);

//   // FIXED: playNext no longer picks random song, uses pre-built shuffle order
//   const playNext = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         // If no shuffle order exists yet, create one
//         if (!shuffleOrder.length) {
//           const { order, pointer } = buildShuffleOrder(
//             queue,
//             current >= 0 ? current : 0,
//           );
//           setShuffleOrder(order);
//           setShufflePointer(pointer);
//           return order[pointer];
//         }

//         const nextPointer = shufflePointer + 1;

//         // If we haven't finished the loop yet, go to next song in shuffle order
//         if (nextPointer < shuffleOrder.length) {
//           setShufflePointer(nextPointer);
//           return shuffleOrder[nextPointer];
//         }

//         // If we finished the loop, create a fresh shuffle order for the next cycle
//         let nextStart = Math.floor(Math.random() * queue.length);

//         // avoid immediate repeat of the just-finished last song
//         const lastPlayed = shuffleOrder[shuffleOrder.length - 1];
//         if (queue.length > 1) {
//           while (nextStart === lastPlayed) {
//             nextStart = Math.floor(Math.random() * queue.length);
//           }
//         }

//         const { order, pointer } = buildShuffleOrder(queue, nextStart);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//         return order[pointer];
//       }

//       // Normal mode: go to next, and wrap to 0 at the end
//       if (current + 1 < queue.length) {
//         return current + 1;
//       }

//       return 0;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer, buildShuffleOrder]);

//   // FIXED: playPrev also uses shuffle order when shuffle is on
//   const playPrev = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         if (!shuffleOrder.length) return current;

//         const prevPointer = shufflePointer - 1;

//         if (prevPointer >= 0) {
//           setShufflePointer(prevPointer);
//           return shuffleOrder[prevPointer];
//         }

//         return shuffleOrder[0];
//       }

//       // Normal mode: go to previous, wrap to last song at beginning
//       return current > 0 ? current - 1 : queue.length - 1;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer]);

//   const reorderQueue = useCallback((newQueue) => {
//     setQueue(newQueue);
//   }, []);

//   const removeFromQueue = useCallback(
//     (trackId) => {
//       setQueue((prev) => {
//         const updated = prev.filter((t) => t.id !== trackId);

//         const removedIndex = prev.findIndex((t) => t.id === trackId);

//         if (removedIndex < currentIndex) {
//           setCurrentIndex((i) => i - 1);
//         }

//         return updated;
//       });
//     },
//     [currentIndex],
//   );

//   // FIXED: clearQueue also clears shuffle states
//   const clearQueue = useCallback(() => {
//     setQueue([]);
//     setCurrentIndex(-1);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//     audioRef.current.pause();
//     audioRef.current.src = "";
//     setPlaying(false);
//   }, []);

//   useEffect(() => {
//     const requestId = ++loadRequestRef.current;
//     let cancelled = false;

//     const isCurrentRequest = () =>
//       !cancelled && loadRequestRef.current === requestId;

//     const loadTrack = async () => {
//       if (!currentTrack) return;

//       const audio = audioRef.current;

//       // Stop the previous native track before loading another one.
//       audio.pause();

//       // Native audio: cache lookup can finish asynchronously.
//       try {
//         const cachedBlob = await getTrack(currentTrack.id);

//         // Never let an older request replace the newly selected track.
//         if (!isCurrentRequest()) return;

//         if (cachedBlob) {
//           audio.src = URL.createObjectURL(cachedBlob);
//         } else {
//           audio.src =
//             currentTrack.external_url ||
//             currentTrack.storage_path ||
//             "";
//         }

//         if (!audio.src) {
//           throw new Error("No playable audio source found.");
//         }

//         audio.load();

//         await audio.play();

//         // The selected track may have changed while play() was pending.
//         if (!isCurrentRequest()) return;

//         setPlaying(true);
//         addRecent(currentTrack);
//         cacheTrack(currentTrack);

//         if (resumeTime > 0) {
//           const timeToResume = resumeTime;
//           setResumeTime(0);

//           // Wait until metadata is available before seeking.
//           if (audio.readyState >= 1) {
//             audio.currentTime = timeToResume;
//           } else {
//             const onMetadata = () => {
//               if (isCurrentRequest()) {
//                 audio.currentTime = Math.min(
//                   timeToResume,
//                   audio.duration || timeToResume,
//                 );
//               }
//             };

//             audio.addEventListener("loadedmetadata", onMetadata, {
//               once: true,
//             });
//           }
//         }

//         saveProgress(currentTrack.id, 0, audio.duration);
//       } catch (err) {
//         if (!isCurrentRequest()) return;
//         if (err.name === "AbortError") return;

//         console.error("Audio playback failed:", err);
//         setPlaying(false);
//       }
//     };

//     loadTrack();

//     return () => {
//       cancelled = true;
//     };
//   }, [currentTrack]);

//   useEffect(() => {
//     const audio = audioRef.current;

//     const onTime = () => {
//       setCurrentTime(audio.currentTime);
//     };

//     const onLoaded = () => setDuration(audio.duration || 0);

//     const onEnded = () => {
//       if (loopOne) {
//         audio.currentTime = 0;
//         audio.play();
//       } else {
//         playNext();
//       }
//     };

//     audio.addEventListener("timeupdate", onTime);
//     audio.addEventListener("loadedmetadata", onLoaded);
//     audio.addEventListener("ended", onEnded);

//     return () => {
//       audio.removeEventListener("timeupdate", onTime);
//       audio.removeEventListener("loadedmetadata", onLoaded);
//       audio.removeEventListener("ended", onEnded);
//     };
//   }, [loopOne, shuffle, playNext]);

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     localStorage.setItem(
//       STORAGE_KEY,
//       JSON.stringify({
//         queue,
//         currentIndex,
//         currentTime,
//         wasPlaying: playing,
//         loopOne,
//         shuffle,
//         shuffleOrder,
//         shufflePointer,
//       }),
//     );
//   }, [
//     queue,
//     currentIndex,
//     currentTime,
//     playing,
//     loopOne,
//     shuffle,
//     shuffleOrder,
//     shufflePointer,
//     STORAGE_KEY,
//   ]);

//   const seekTo = (sec) => {
//     const audio = audioRef.current;
//     if (!audio) return;
//     audio.currentTime = Math.max(0, Math.min(sec, audio.duration || 0));
//   };

//   const value = useMemo(
//     () => ({
//       audioRef,
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       setNewQueue,
//       setResumeTime,
//       playAll,
//       shufflePlay,
//       addToQueue,
//       playNextInsert,
//       playNext,
//       playPrev,
//       togglePlay,
//       setLoopOne,
//       setShuffle,
//       seekTo,
//       removeFromQueue,
//       clearQueue,
//       reorderQueue,
//       shuffleOrder,
//       shufflePointer,
//     }),
//     [
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       shuffleOrder,
//       shufflePointer,
//     ],
//   );

//   return (
//     <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
//   );
// }

// export function useAudio() {
//   return useContext(AudioContext);
// }



// 

// progress bar
// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
//   useCallback,
//   useMemo,
// } from "react";
// import useRecent from "../hooks/useRecent";
// import { useAuth } from "./AuthContext";
// import { supabase } from "../supabaseClient";
// import { cacheTrack } from "../utils/cacheTrack";
// import { getTrack } from "../utils/offlineCache";

// const AudioContext = createContext(null);

// // Tracks saved from the old YouTube integration have no audio source of
// // their own. They can't be played anymore, so they are dropped when a
// // saved queue is restored from localStorage.
// const isLegacyYoutubeOnly = (t) =>
//   !!t?.youtube_video_id && !t?.external_url && !t?.storage_path;

// export function AudioProvider({ children }) {
//   const { user } = useAuth();
//   const STORAGE_KEY = user ? `audio_state_${user.id}` : null;
//   const audioRef = useRef(new Audio());
//   const loadRequestRef = useRef(0);
//   const playNextRef = useRef(() => {});
//   const failedSkipsRef = useRef(0);
//   const { addRecent } = useRecent();
//   const [resumeTime, setResumeTime] = useState(0);

//   // Player states
//   const [queue, setQueue] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(-1);
//   const [playing, setPlaying] = useState(false);
//   const [loopOne, setLoopOne] = useState(false);
//   const [shuffle, setShuffle] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);

//   // NEW: States for shuffle order (prevents repeats within one loop)
//   const [shuffleOrder, setShuffleOrder] = useState([]);
//   const [shufflePointer, setShufflePointer] = useState(0);

//   const saveProgress = async (trackId, position, duration) => {
//     if (!user || !trackId) return;
//     if (position < 5) return;

//     await supabase.from("continue_listening").upsert(
//       {
//         user_id: user.id,
//         track_id: trackId,
//         last_position: Math.floor(position),
//         duration: Math.floor(duration || 0),
//         updated_at: new Date(),
//       },
//       {
//         onConflict: "user_id,track_id",
//       },
//     );
//   };

//   const currentTrack =
//     currentIndex >= 0 && currentIndex < queue.length
//       ? queue[currentIndex]
//       : null;

//   // NEW: Fisher-Yates shuffle helper - creates one full order without repeats
//   const buildShuffleOrder = useCallback((tracks, startIndex = 0) => {
//     if (!tracks?.length) return { order: [], pointer: 0 };

//     const indices = tracks.map((_, i) => i);
//     const remaining = indices.filter((i) => i !== startIndex);

//     // Fisher-Yates shuffle
//     for (let i = remaining.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
//     }

//     const order = [startIndex, ...remaining];
//     return { order, pointer: 0 };
//   }, []);

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

//     if (!saved) return;

//     let {
//       queue: savedQueue,
//       currentIndex: savedIndex,
//       currentTime,
//       wasPlaying,
//       loopOne,
//       shuffle,
//       shuffleOrder,
//       shufflePointer,
//     } = saved;

//     if (!savedQueue?.length) return;

//     // Drop leftover YouTube-only tracks and remap the current index.
//     const queue = savedQueue.filter((t) => !isLegacyYoutubeOnly(t));
//     if (!queue.length) return;

//     const removedCount = savedQueue.length - queue.length;
//     let currentIndex = savedIndex;

//     if (removedCount > 0) {
//       const keptBefore = savedQueue
//         .slice(0, Math.max(savedIndex, 0))
//         .filter((t) => !isLegacyYoutubeOnly(t)).length;
//       const currentWasKept =
//         savedQueue[savedIndex] && !isLegacyYoutubeOnly(savedQueue[savedIndex]);

//       currentIndex = Math.min(keptBefore, queue.length - 1);
//       // The saved shuffle order refers to old indices, so reset it.
//       shuffleOrder = [];
//       shufflePointer = 0;
//       if (!currentWasKept) {
//         currentTime = 0;
//         wasPlaying = false;
//       }
//     }

//     setQueue(queue);
//     setCurrentIndex(currentIndex);
//     setLoopOne(loopOne);
//     setShuffle(!!shuffle);
//     setShuffleOrder(shuffleOrder || []);
//     setShufflePointer(shufflePointer || 0);

//     const audio = audioRef.current;

//     setTimeout(() => {
//       const track = queue[currentIndex];
//       if (track) {
//         audio.currentTime = currentTime || 0;

//         if (wasPlaying) {
//           audio.play().catch(() => {});
//           setPlaying(true);
//         }
//       }
//     }, 0);
//   }, [STORAGE_KEY]);

//   useEffect(() => {
//     if (!currentTrack) return;

//     const interval = setInterval(() => {
//       if (!audioRef.current.paused) {
//         saveProgress(
//           currentTrack.id,
//           audioRef.current.currentTime || 0,
//           audioRef.current.duration || 0,
//         );
//       }
//     }, 10000);

//     return () => {
//       clearInterval(interval);

//       if (currentTrack) {
//         saveProgress(
//           currentTrack.id,
//           audioRef.current.currentTime || 0,
//           audioRef.current.duration || 0,
//         );
//       }
//     };
//   }, [currentTrack, user]);

//   // FIXED: setNewQueue now also builds shuffle order if shuffle is on
//   const setNewQueue = useCallback(
//     (tracks, index) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setCurrentIndex(index);

//       if (shuffle) {
//         const { order, pointer } = buildShuffleOrder(tracks, index);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//       } else {
//         setShuffleOrder([]);
//         setShufflePointer(0);
//       }
//     },
//     [shuffle, buildShuffleOrder],
//   );

//   // FIXED: playAll always uses original order, no shuffle
//   const playAll = useCallback((tracks) => {
//     if (!tracks?.length) return;

//     setQueue(tracks);
//     setCurrentIndex(0);
//     setShuffle(false);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//   }, []);

//   const shufflePlay = useCallback(
//     (tracks) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setShuffle(true);

//       const startIndex = Math.floor(Math.random() * tracks.length);

//       const { order, pointer } = buildShuffleOrder(tracks, startIndex);

//       setShuffleOrder(order);
//       setShufflePointer(pointer);

//       setCurrentIndex(order[pointer]);
//     },
//     [buildShuffleOrder],
//   );

//   const addToQueue = useCallback((track) => {
//     if (!track) return;

//     setQueue((prev) => {
//       if (prev.some((t) => t.id === track.id)) return prev;
//       return [...prev, track];
//     });
//   }, []);

//   const playNextInsert = useCallback(
//     (track) => {
//       if (!track) return;

//       setQueue((prev) => {
//         if (!prev.length) {
//           setCurrentIndex(0);
//           return [track];
//         }

//         const newQueue = [...prev];
//         newQueue.splice(currentIndex + 1, 0, track);
//         return newQueue;
//       });
//     },
//     [currentIndex],
//   );

//   const togglePlay = useCallback(() => {
//     const audio = audioRef.current;
//     if (!audio.src) return;

//     if (audio.paused) {
//       audio.play().then(() => setPlaying(true));
//     } else {
//       audio.pause();
//       setPlaying(false);
//     }
//   }, []);

//   // FIXED: playNext no longer picks random song, uses pre-built shuffle order
//   const playNext = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         // If no shuffle order exists yet, create one
//         if (!shuffleOrder.length) {
//           const { order, pointer } = buildShuffleOrder(
//             queue,
//             current >= 0 ? current : 0,
//           );
//           setShuffleOrder(order);
//           setShufflePointer(pointer);
//           return order[pointer];
//         }

//         const nextPointer = shufflePointer + 1;

//         // If we haven't finished the loop yet, go to next song in shuffle order
//         if (nextPointer < shuffleOrder.length) {
//           setShufflePointer(nextPointer);
//           return shuffleOrder[nextPointer];
//         }

//         // If we finished the loop, create a fresh shuffle order for the next cycle
//         let nextStart = Math.floor(Math.random() * queue.length);

//         // avoid immediate repeat of the just-finished last song
//         const lastPlayed = shuffleOrder[shuffleOrder.length - 1];
//         if (queue.length > 1) {
//           while (nextStart === lastPlayed) {
//             nextStart = Math.floor(Math.random() * queue.length);
//           }
//         }

//         const { order, pointer } = buildShuffleOrder(queue, nextStart);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//         return order[pointer];
//       }

//       // Normal mode: go to next, and wrap to 0 at the end
//       if (current + 1 < queue.length) {
//         return current + 1;
//       }

//       return 0;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer, buildShuffleOrder]);

//   // Keep a ref to the latest playNext so the load effect can skip a broken track.
//   useEffect(() => {
//     playNextRef.current = playNext;
//   }, [playNext]);

//   // FIXED: playPrev also uses shuffle order when shuffle is on
//   const playPrev = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         if (!shuffleOrder.length) return current;

//         const prevPointer = shufflePointer - 1;

//         if (prevPointer >= 0) {
//           setShufflePointer(prevPointer);
//           return shuffleOrder[prevPointer];
//         }

//         return shuffleOrder[0];
//       }

//       // Normal mode: go to previous, wrap to last song at beginning
//       return current > 0 ? current - 1 : queue.length - 1;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer]);

//   const reorderQueue = useCallback((newQueue) => {
//     setQueue(newQueue);
//   }, []);

//   const removeFromQueue = useCallback(
//     (trackId) => {
//       setQueue((prev) => {
//         const updated = prev.filter((t) => t.id !== trackId);

//         const removedIndex = prev.findIndex((t) => t.id === trackId);

//         if (removedIndex < currentIndex) {
//           setCurrentIndex((i) => i - 1);
//         }

//         return updated;
//       });
//     },
//     [currentIndex],
//   );

//   // FIXED: clearQueue also clears shuffle states
//   const clearQueue = useCallback(() => {
//     setQueue([]);
//     setCurrentIndex(-1);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//     audioRef.current.pause();
//     audioRef.current.src = "";
//     setPlaying(false);
//   }, []);

//   useEffect(() => {
//     const requestId = ++loadRequestRef.current;
//     let cancelled = false;

//     const isCurrentRequest = () =>
//       !cancelled && loadRequestRef.current === requestId;

//     const loadTrack = async () => {
//       if (!currentTrack) return;

//       const audio = audioRef.current;

//       // Stop the previous native track before loading another one.
//       audio.pause();

//       // Native audio: cache lookup can finish asynchronously.
//       try {
//         const cachedBlob = await getTrack(currentTrack.id);

//         // Never let an older request replace the newly selected track.
//         if (!isCurrentRequest()) return;

//         if (cachedBlob) {
//           audio.src = URL.createObjectURL(cachedBlob);
//         } else {
//           audio.src =
//             currentTrack.external_url ||
//             currentTrack.storage_path ||
//             "";
//         }

//         if (!audio.src) {
//           throw new Error("No playable audio source found.");
//         }

//         // Setting src already starts loading; no extra audio.load() needed.
//         await audio.play();

//         // The selected track may have changed while play() was pending.
//         if (!isCurrentRequest()) return;

//         failedSkipsRef.current = 0;
//         setPlaying(true);
//         addRecent(currentTrack);
//         cacheTrack(currentTrack);

//         if (resumeTime > 0) {
//           const timeToResume = resumeTime;
//           setResumeTime(0);

//           // Wait until metadata is available before seeking.
//           if (audio.readyState >= 1) {
//             audio.currentTime = timeToResume;
//           } else {
//             const onMetadata = () => {
//               if (isCurrentRequest()) {
//                 audio.currentTime = Math.min(
//                   timeToResume,
//                   audio.duration || timeToResume,
//                 );
//               }
//             };

//             audio.addEventListener("loadedmetadata", onMetadata, {
//               once: true,
//             });
//           }
//         }

//         saveProgress(currentTrack.id, 0, audio.duration);
//       } catch (err) {
//         if (!isCurrentRequest()) return;
//         if (err.name === "AbortError") return;

//         console.error("Audio playback failed:", err.name, err.message, currentTrack);
//         setPlaying(false);

//         // Autoplay blocks are not a bad track, so don't skip on those.
//         // For a genuinely broken track, move on instead of killing the queue,
//         // but never loop more times than there are songs.
//         if (
//           err.name !== "NotAllowedError" &&
//           failedSkipsRef.current < queue.length - 1
//         ) {
//           failedSkipsRef.current += 1;
//           playNextRef.current();
//         }
//       }
//     };

//     loadTrack();

//     return () => {
//       cancelled = true;
//     };
//   }, [currentTrack]);

//   useEffect(() => {
//     const audio = audioRef.current;

//     const onTime = () => {
//       setCurrentTime(audio.currentTime);
//     };

//     const onLoaded = () => setDuration(audio.duration || 0);

//     const onEnded = () => {
//       if (loopOne) {
//         audio.currentTime = 0;
//         audio.play();
//       } else {
//         playNext();
//       }
//     };

//     audio.addEventListener("timeupdate", onTime);
//     audio.addEventListener("loadedmetadata", onLoaded);
//     audio.addEventListener("ended", onEnded);

//     return () => {
//       audio.removeEventListener("timeupdate", onTime);
//       audio.removeEventListener("loadedmetadata", onLoaded);
//       audio.removeEventListener("ended", onEnded);
//     };
//   }, [loopOne, shuffle, playNext]);

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     localStorage.setItem(
//       STORAGE_KEY,
//       JSON.stringify({
//         queue,
//         currentIndex,
//         currentTime,
//         wasPlaying: playing,
//         loopOne,
//         shuffle,
//         shuffleOrder,
//         shufflePointer,
//       }),
//     );
//   }, [
//     queue,
//     currentIndex,
//     currentTime,
//     playing,
//     loopOne,
//     shuffle,
//     shuffleOrder,
//     shufflePointer,
//     STORAGE_KEY,
//   ]);

//   const seekTo = (sec) => {
//     const audio = audioRef.current;
//     if (!audio) return;
//     audio.currentTime = Math.max(0, Math.min(sec, audio.duration || 0));
//   };

//   const value = useMemo(
//     () => ({
//       audioRef,
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       setNewQueue,
//       setResumeTime,
//       playAll,
//       shufflePlay,
//       addToQueue,
//       playNextInsert,
//       playNext,
//       playPrev,
//       togglePlay,
//       setLoopOne,
//       setShuffle,
//       seekTo,
//       removeFromQueue,
//       clearQueue,
//       reorderQueue,
//       shuffleOrder,
//       shufflePointer,
//     }),
//     [
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       shuffleOrder,
//       shufflePointer,
//     ],
//   );

//   return (
//     <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
//   );
// }

// export function useAudio() {
//   return useContext(AudioContext);
// }



// 

// // progress bar
// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
//   useCallback,
//   useMemo,
// } from "react";
// import useRecent from "../hooks/useRecent";
// import { useAuth } from "./AuthContext";
// import { supabase } from "../supabaseClient";
// import { cacheTrack } from "../utils/cacheTrack";
// import { getTrack } from "../utils/offlineCache";

// const AudioContext = createContext(null);

// // --- NEW: YouTube IFrame API loader -----------------------------------
// // Loads the YouTube IFrame API script once and resolves with window.YT
// // when it's ready. Safe to call multiple times; only loads the script once.
// function loadYouTubeIframeAPI() {
//   return new Promise((resolve) => {
//     if (window.YT && window.YT.Player) {
//       resolve(window.YT);
//       return;
//     }
//     const existingCallback = window.onYouTubeIframeAPIReady;
//     window.onYouTubeIframeAPIReady = () => {
//       if (existingCallback) existingCallback();
//       resolve(window.YT);
//     };
//     if (!document.getElementById("youtube-iframe-api-script")) {
//       const tag = document.createElement("script");
//       tag.id = "youtube-iframe-api-script";
//       tag.src = "https://www.youtube.com/iframe_api";
//       document.body.appendChild(tag);
//     }
//   });
// }
// // ------------------------------------------------------------------------

// export function AudioProvider({ children }) {
//   const { user } = useAuth();
//   const STORAGE_KEY = user ? `audio_state_${user.id}` : null;
//   const audioRef = useRef(new Audio());
//   const loadRequestRef = useRef(0);
//   const { addRecent } = useRecent();
//   const [resumeTime, setResumeTime] = useState(0);

//   // Player states
//   const [queue, setQueue] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(-1);
//   const [playing, setPlaying] = useState(false);
//   const [loopOne, setLoopOne] = useState(false);
//   const [shuffle, setShuffle] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);

//   // NEW: States for shuffle order (prevents repeats within one loop)
//   const [shuffleOrder, setShuffleOrder] = useState([]);
//   const [shufflePointer, setShufflePointer] = useState(0);

//   // --- NEW: YouTube player refs -----------------------------------------
//   const ytPlayerRef = useRef(null);
//   const ytReadyPromiseRef = useRef(null);
//   const loopOneRef = useRef(loopOne);
//   const playNextRef = useRef(() => {});
//   // ------------------------------------------------------------------------

//   const saveProgress = async (trackId, position, duration) => {
//     if (!user || !trackId) return;
//     if (position < 5) return;

//     await supabase.from("continue_listening").upsert(
//       {
//         user_id: user.id,
//         track_id: trackId,
//         last_position: Math.floor(position),
//         duration: Math.floor(duration || 0),
//         updated_at: new Date(),
//       },
//       {
//         onConflict: "user_id,track_id",
//       },
//     );
//   };

//   const currentTrack =
//     currentIndex >= 0 && currentIndex < queue.length
//       ? queue[currentIndex]
//       : null;

//   // NEW: is the currently loaded track a YouTube-sourced track?
//   const isYoutubeTrack = !!currentTrack?.youtube_video_id;

//   // NEW: unified getters so progress-saving / UI code doesn't need to
//   // know which underlying player is active.
//   const getPlaybackTime = useCallback(() => {
//     if (isYoutubeTrack && ytPlayerRef.current?.getCurrentTime) {
//       return ytPlayerRef.current.getCurrentTime() || 0;
//     }
//     return audioRef.current.currentTime || 0;
//   }, [isYoutubeTrack]);

//   const getPlaybackDuration = useCallback(() => {
//     if (isYoutubeTrack && ytPlayerRef.current?.getDuration) {
//       return ytPlayerRef.current.getDuration() || 0;
//     }
//     return audioRef.current.duration || 0;
//   }, [isYoutubeTrack]);

//   // NEW: Fisher-Yates shuffle helper - creates one full order without repeats
//   const buildShuffleOrder = useCallback((tracks, startIndex = 0) => {
//     if (!tracks?.length) return { order: [], pointer: 0 };

//     const indices = tracks.map((_, i) => i);
//     const remaining = indices.filter((i) => i !== startIndex);

//     // Fisher-Yates shuffle
//     for (let i = remaining.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
//     }

//     const order = [startIndex, ...remaining];
//     return { order, pointer: 0 };
//   }, []);

//   // --- NEW: keep refs in sync so the YT event handler (created once on
//   // mount) always sees the latest loopOne / playNext without re-creating
//   // the player. -------------------------------------------------------
//   useEffect(() => {
//     loopOneRef.current = loopOne;
//   }, [loopOne]);

//   // --- NEW: create the hidden YouTube player once on mount --------------
//   // IMPORTANT: the container div is created with plain DOM APIs and
//   // appended directly to document.body, OUTSIDE of React's rendering.
//   // The YouTube IFrame API replaces this div with a real <iframe> internally;
//   // if React also tried to render/reconcile this same node, the two would
//   // fight over it and throw "insertBefore" / "not a child of this node"
//   // errors. Keeping it fully outside JSX avoids that entirely.
//   useEffect(() => {
//     const container = document.createElement("div");
//     container.id = "yt-audio-player-container";
//     container.style.position = "absolute";
//     container.style.top = "-9999px";
//     container.style.left = "-9999px";
//     // 200x200 rather than 0x0/1x1 -- very small player sizes are known to
//     // cause flaky internal behavior (duration/quality calc glitches) in
//     // the YouTube IFrame API.
//     container.style.width = "200px";
//     container.style.height = "200px";
//     document.body.appendChild(container);

//     ytReadyPromiseRef.current = new Promise((resolve) => {
//       loadYouTubeIframeAPI().then((YT) => {
//         const player = new YT.Player(container, {
//           height: "200",
//           width: "200",
//           playerVars: { controls: 0, disablekb: 1 },
//           events: {
//             onReady: () => {
//               ytPlayerRef.current = player;
//               resolve(player);
//             },
//             onStateChange: (event) => {
//               if (event.data === window.YT.PlayerState.ENDED) {
//                 if (loopOneRef.current) {
//                   player.seekTo(0, true);
//                   player.playVideo();
//                 } else {
//                   playNextRef.current();
//                 }
//               }
//             },
//           },
//         });
//       });
//     });

//     return () => {
//       if (ytPlayerRef.current?.destroy) {
//         try {
//           ytPlayerRef.current.destroy();
//         } catch {
//           // ignore
//         }
//       }
//       if (container.parentNode) {
//         container.parentNode.removeChild(container);
//       }
//     };
//   }, []);
//   // ------------------------------------------------------------------------

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

//     if (!saved) return;

//     const {
//       queue,
//       currentIndex,
//       currentTime,
//       wasPlaying,
//       loopOne,
//       shuffle,
//       shuffleOrder,
//       shufflePointer,
//     } = saved;

//     if (!queue?.length) return;

//     setQueue(queue);
//     setCurrentIndex(currentIndex);
//     setLoopOne(loopOne);
//     setShuffle(!!shuffle);
//     setShuffleOrder(shuffleOrder || []);
//     setShufflePointer(shufflePointer || 0);

//     const audio = audioRef.current;

//     setTimeout(() => {
//       // NEW: only resume native audio's currentTime here; YouTube tracks
//       // resume via resumeTime in the loadTrack effect below instead,
//       // since the YT player may not be ready yet at this point.
//       const track = queue[currentIndex];
//       if (track && !track.youtube_video_id) {
//         audio.currentTime = currentTime || 0;

//         if (wasPlaying) {
//           audio.play().catch(() => {});
//           setPlaying(true);
//         }
//       } else if (track && wasPlaying) {
//         setPlaying(true);
//       }
//     }, 0);
//   }, [STORAGE_KEY]);

//   useEffect(() => {
//     if (!currentTrack) return;

//     const interval = setInterval(() => {
//       // CHANGED: use the unified getter instead of reading audioRef directly,
//       // so progress saves correctly for YouTube tracks too.
//       const isPlayingNow = isYoutubeTrack
//         ? ytPlayerRef.current?.getPlayerState?.() ===
//           window.YT?.PlayerState?.PLAYING
//         : !audioRef.current.paused;

//       if (isPlayingNow) {
//         saveProgress(currentTrack.id, getPlaybackTime(), getPlaybackDuration());
//       }
//     }, 10000);

//     return () => {
//       clearInterval(interval);

//       if (currentTrack) {
//         saveProgress(currentTrack.id, getPlaybackTime(), getPlaybackDuration());
//       }
//     };
//   }, [currentTrack, user, isYoutubeTrack]);

//   // FIXED: setNewQueue now also builds shuffle order if shuffle is on
//   const setNewQueue = useCallback(
//     (tracks, index) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setCurrentIndex(index);

//       if (shuffle) {
//         const { order, pointer } = buildShuffleOrder(tracks, index);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//       } else {
//         setShuffleOrder([]);
//         setShufflePointer(0);
//       }
//     },
//     [shuffle, buildShuffleOrder],
//   );

//   // FIXED: playAll always uses original order, no shuffle
//   const playAll = useCallback((tracks) => {
//     if (!tracks?.length) return;

//     setQueue(tracks);
//     setCurrentIndex(0);
//     setShuffle(false);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//   }, []);

//   const shufflePlay = useCallback(
//     (tracks) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setShuffle(true);

//       const startIndex = Math.floor(Math.random() * tracks.length);

//       const { order, pointer } = buildShuffleOrder(tracks, startIndex);

//       setShuffleOrder(order);
//       setShufflePointer(pointer);

//       setCurrentIndex(order[pointer]);
//     },
//     [buildShuffleOrder],
//   );

//   const addToQueue = useCallback((track) => {
//     if (!track) return;

//     setQueue((prev) => {
//       if (prev.some((t) => t.id === track.id)) return prev;
//       return [...prev, track];
//     });
//   }, []);

//   const playNextInsert = useCallback(
//     (track) => {
//       if (!track) return;

//       setQueue((prev) => {
//         if (!prev.length) {
//           setCurrentIndex(0);
//           return [track];
//         }

//         const newQueue = [...prev];
//         newQueue.splice(currentIndex + 1, 0, track);
//         return newQueue;
//       });
//     },
//     [currentIndex],
//   );

//   // CHANGED: togglePlay now branches on source type
//   const togglePlay = useCallback(() => {
//     if (isYoutubeTrack) {
//       const yt = ytPlayerRef.current;
//       if (!yt || !window.YT) return;

//       const state = yt.getPlayerState();
//       if (state === window.YT.PlayerState.PLAYING) {
//         yt.pauseVideo();
//         setPlaying(false);
//       } else {
//         yt.playVideo();
//         setPlaying(true);
//       }
//       return;
//     }

//     const audio = audioRef.current;
//     if (!audio.src) return;

//     if (audio.paused) {
//       audio.play().then(() => setPlaying(true));
//     } else {
//       audio.pause();
//       setPlaying(false);
//     }
//   }, [isYoutubeTrack]);

//   // FIXED: playNext no longer picks random song, uses pre-built shuffle order
//   const playNext = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         // If no shuffle order exists yet, create one
//         if (!shuffleOrder.length) {
//           const { order, pointer } = buildShuffleOrder(
//             queue,
//             current >= 0 ? current : 0,
//           );
//           setShuffleOrder(order);
//           setShufflePointer(pointer);
//           return order[pointer];
//         }

//         const nextPointer = shufflePointer + 1;

//         // If we haven't finished the loop yet, go to next song in shuffle order
//         if (nextPointer < shuffleOrder.length) {
//           setShufflePointer(nextPointer);
//           return shuffleOrder[nextPointer];
//         }

//         // If we finished the loop, create a fresh shuffle order for the next cycle
//         let nextStart = Math.floor(Math.random() * queue.length);

//         // avoid immediate repeat of the just-finished last song
//         const lastPlayed = shuffleOrder[shuffleOrder.length - 1];
//         if (queue.length > 1) {
//           while (nextStart === lastPlayed) {
//             nextStart = Math.floor(Math.random() * queue.length);
//           }
//         }

//         const { order, pointer } = buildShuffleOrder(queue, nextStart);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//         return order[pointer];
//       }

//       // Normal mode: go to next, and wrap to 0 at the end
//       if (current + 1 < queue.length) {
//         return current + 1;
//       }

//       return 0;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer, buildShuffleOrder]);

//   // NEW: keep a ref to the latest playNext for the YT onStateChange handler
//   useEffect(() => {
//     playNextRef.current = playNext;
//   }, [playNext]);

//   // FIXED: playPrev also uses shuffle order when shuffle is on
//   const playPrev = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         if (!shuffleOrder.length) return current;

//         const prevPointer = shufflePointer - 1;

//         if (prevPointer >= 0) {
//           setShufflePointer(prevPointer);
//           return shuffleOrder[prevPointer];
//         }

//         return shuffleOrder[0];
//       }

//       // Normal mode: go to previous, wrap to last song at beginning
//       return current > 0 ? current - 1 : queue.length - 1;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer]);

//   const reorderQueue = useCallback((newQueue) => {
//     setQueue(newQueue);
//   }, []);

//   const removeFromQueue = useCallback(
//     (trackId) => {
//       setQueue((prev) => {
//         const updated = prev.filter((t) => t.id !== trackId);

//         const removedIndex = prev.findIndex((t) => t.id === trackId);

//         if (removedIndex < currentIndex) {
//           setCurrentIndex((i) => i - 1);
//         }

//         return updated;
//       });
//     },
//     [currentIndex],
//   );

//   // FIXED: clearQueue also clears shuffle states
//   const clearQueue = useCallback(() => {
//     setQueue([]);
//     setCurrentIndex(-1);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//     audioRef.current.pause();
//     audioRef.current.src = "";
//     // NEW: stop YouTube playback too, if a YT track was playing
//     if (ytPlayerRef.current?.stopVideo) {
//       try {
//         ytPlayerRef.current.stopVideo();
//       } catch {
//         // player may not be ready; safe to ignore
//       }
//     }
//     setPlaying(false);
//   }, []);

  
//   // useEffect(() => {
//   //   const loadTrack = async () => {
//   //     if (!currentTrack) return;

//   //     // --- NEW: YouTube-sourced track path ---------------------------
//   //     if (currentTrack.youtube_video_id) {
//   //       // Make sure native audio isn't also playing underneath
//   //       audioRef.current.pause();

//   //       const yt = ytPlayerRef.current || (await ytReadyPromiseRef.current);
//   //       if (!yt) return;

//   //       yt.loadVideoById(currentTrack.youtube_video_id);
//   //       setPlaying(true);
//   //       addRecent(currentTrack);
//   //       // Deliberately no cacheTrack()/offline caching for YouTube tracks.

//   //       if (resumeTime > 0) {
//   //         // give the player a moment to actually load before seeking
//   //         setTimeout(() => {
//   //           try {
//   //             yt.seekTo(resumeTime, true);
//   //           } catch {
//   //             // ignore if not ready yet
//   //           }
//   //         }, 500);
//   //         setResumeTime(0);
//   //       }

//   //       saveProgress(currentTrack.id, 0, 0);
//   //       return;
//   //     }
//   //     // ------------------------------------------------------------------

//   //     // ---- existing native-audio logic (unchanged) ----
//   //     const audio = audioRef.current;

//   //     // NEW: stop any YouTube playback first, in case the previous track was one
//   //     if (ytPlayerRef.current?.stopVideo) {
//   //       try {
//   //         ytPlayerRef.current.stopVideo();
//   //       } catch {
//   //         // ignore
//   //       }
//   //     }

//   //     try {
//   //       const cachedBlob = await getTrack(currentTrack.id);

//   //       if (cachedBlob) {
//   //         const blobUrl = URL.createObjectURL(cachedBlob);
//   //         audio.src = blobUrl;
//   //       } else {
//   //         audio.src =
//   //           currentTrack.external_url || currentTrack.storage_path || "";
//   //       }

//   //       await audio.play();

//   //       setPlaying(true);

//   //       addRecent(currentTrack);

//   //       cacheTrack(currentTrack);

//   //       if (resumeTime > 0) {
//   //         audio.currentTime = resumeTime;
//   //         setResumeTime(0);
//   //       }

//   //       saveProgress(currentTrack.id, 0, audio.duration);
//   //     } catch (err) {
//   //       if (err.name === "AbortError") {
//   //         return;
//   //       }

//   //       console.error(err);
//   //       setPlaying(false);
//   //     }
//   //   };

//   //   loadTrack();
//   // }, [currentTrack]);


// useEffect(() => {
//   const requestId = ++loadRequestRef.current;
//   let cancelled = false;

//   const isCurrentRequest = () =>
//     !cancelled && loadRequestRef.current === requestId;

//   const loadTrack = async () => {
//     if (!currentTrack) return;

//     const audio = audioRef.current;

//     // Stop the previous native track before loading another one.
//     audio.pause();

//     // YouTube branch: preserve the existing support.
//     if (currentTrack.youtube_video_id) {
//       try {
//         const yt =
//           ytPlayerRef.current || (await ytReadyPromiseRef.current);

//         if (!isCurrentRequest() || !yt) return;

//         yt.loadVideoById(currentTrack.youtube_video_id);

//         if (!isCurrentRequest()) return;

//         setPlaying(true);
//         addRecent(currentTrack);

//         if (resumeTime > 0) {
//           const timeToResume = resumeTime;
//           setResumeTime(0);

//           setTimeout(() => {
//             if (!isCurrentRequest()) return;

//             try {
//               yt.seekTo(timeToResume, true);
//             } catch (err) {
//               console.warn("Unable to restore playback position:", err);
//             }
//           }, 500);
//         }

//         saveProgress(currentTrack.id, 0, 0);
//       } catch (err) {
//         if (!isCurrentRequest()) return;

//         console.error("Unable to load YouTube track:", err);
//         setPlaying(false);
//       }

//       return;
//     }

//     // Native audio: cache lookup can finish asynchronously.
//     try {
//       if (ytPlayerRef.current?.stopVideo) {
//         try {
//           ytPlayerRef.current.stopVideo();
//         } catch {
//           // Ignore an unavailable YouTube player.
//         }
//       }

//       const cachedBlob = await getTrack(currentTrack.id);

//       // Never let an older request replace the newly selected track.
//       if (!isCurrentRequest()) return;

//       if (cachedBlob) {
//         audio.src = URL.createObjectURL(cachedBlob);
//       } else {
//         audio.src =
//           currentTrack.external_url ||
//           currentTrack.storage_path ||
//           "";
//       }

//       if (!audio.src) {
//         throw new Error("No playable audio source found.");
//       }

//       audio.load();

//       await audio.play();

//       // The selected track may have changed while play() was pending.
//       if (!isCurrentRequest()) return;

//       setPlaying(true);
//       addRecent(currentTrack);
//       cacheTrack(currentTrack);

//       if (resumeTime > 0) {
//         const timeToResume = resumeTime;
//         setResumeTime(0);

//         // Wait until metadata is available before seeking.
//         if (audio.readyState >= 1) {
//           audio.currentTime = timeToResume;
//         } else {
//           const onMetadata = () => {
//             if (isCurrentRequest()) {
//               audio.currentTime = Math.min(
//                 timeToResume,
//                 audio.duration || timeToResume,
//               );
//             }
//           };

//           audio.addEventListener("loadedmetadata", onMetadata, {
//             once: true,
//           });
//         }
//       }

//       saveProgress(currentTrack.id, 0, audio.duration);
//     } catch (err) {
//       if (!isCurrentRequest()) return;
//       if (err.name === "AbortError") return;

//       console.error("Audio playback failed:", err);
//       setPlaying(false);
//     }
//   };

//   loadTrack();

//   return () => {
//     cancelled = true;
//   };
// }, [currentTrack]);



//   useEffect(() => {
//     const audio = audioRef.current;

//     const onTime = () => {
//       setCurrentTime(audio.currentTime);
//     };

//     const onLoaded = () => setDuration(audio.duration || 0);

//     const onEnded = () => {
//       if (loopOne) {
//         audio.currentTime = 0;
//         audio.play();
//       } else {
//         playNext();
//       }
//     };

//     audio.addEventListener("timeupdate", onTime);
//     audio.addEventListener("loadedmetadata", onLoaded);
//     audio.addEventListener("ended", onEnded);

//     return () => {
//       audio.removeEventListener("timeupdate", onTime);
//       audio.removeEventListener("loadedmetadata", onLoaded);
//       audio.removeEventListener("ended", onEnded);
//     };
//   }, [loopOne, shuffle, playNext]);

//   // --- NEW: poll currentTime/duration for YouTube tracks, since the
//   // IFrame API has no timeupdate event like <audio> does. ---------------
//   useEffect(() => {
//     if (!isYoutubeTrack) return;

//     const interval = setInterval(() => {
//       const yt = ytPlayerRef.current;
//       if (
//         !yt ||
//         typeof yt.getCurrentTime !== "function" ||
//         typeof yt.getDuration !== "function"
//       ) {
//         return;
//       }
//       setCurrentTime(yt.getCurrentTime() || 0);
//       setDuration(yt.getDuration() || 0);
//     }, 500);

//     return () => clearInterval(interval);
//   }, [isYoutubeTrack, currentTrack]);
//   // ------------------------------------------------------------------------

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     localStorage.setItem(
//       STORAGE_KEY,
//       JSON.stringify({
//         queue,
//         currentIndex,
//         currentTime,
//         wasPlaying: playing,
//         loopOne,
//         shuffle,
//         shuffleOrder,
//         shufflePointer,
//       }),
//     );
//   }, [
//     queue,
//     currentIndex,
//     currentTime,
//     playing,
//     loopOne,
//     shuffle,
//     shuffleOrder,
//     shufflePointer,
//     STORAGE_KEY,
//   ]);

//   // CHANGED: seekTo now branches on source type
//   const seekTo = (sec) => {
//     if (isYoutubeTrack) {
//       const yt = ytPlayerRef.current;
//       if (!yt) return;
//       yt.seekTo(Math.max(0, sec), true);
//       return;
//     }

//     const audio = audioRef.current;
//     if (!audio) return;
//     audio.currentTime = Math.max(0, Math.min(sec, audio.duration || 0));
//   };

//   const value = useMemo(
//     () => ({
//       audioRef,
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       setNewQueue,
//       setResumeTime,
//       playAll,
//       shufflePlay,
//       addToQueue,
//       playNextInsert,
//       playNext,
//       playPrev,
//       togglePlay,
//       setLoopOne,
//       setShuffle,
//       seekTo,
//       removeFromQueue,
//       clearQueue,
//       reorderQueue,
//       shuffleOrder,
//       shufflePointer,
//       isYoutubeTrack, // NEW: exposed in case UI wants to show a YouTube badge/icon
//     }),
//     [
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       shuffleOrder,
//       shufflePointer,
//       isYoutubeTrack,
//     ],
//   );

//   // NOTE: the YouTube player's container div is created and managed with
//   // plain DOM APIs in the effect above -- it is intentionally NOT rendered
//   // here via JSX, to avoid React and the YouTube IFrame API fighting over
//   // the same DOM node (see comment above).
//   return (
//     <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
//   );
// }

// export function useAudio() {
//   return useContext(AudioContext);
// }




// 
// progress bar
// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
//   useCallback,
//   useMemo,
// } from "react";
// import useRecent from "../hooks/useRecent";
// import { useAuth } from "./AuthContext";
// import { supabase } from "../supabaseClient";
// import { cacheTrack } from "../utils/cacheTrack";
// import { getTrack } from "../utils/offlineCache";

// const AudioContext = createContext(null);

// // Tracks saved from the old YouTube integration have no audio source of
// // their own. They can't be played anymore, so they are dropped when a
// // saved queue is restored from localStorage.
// const isLegacyYoutubeOnly = (t) =>
//   !!t?.youtube_video_id && !t?.external_url && !t?.storage_path;

// export function AudioProvider({ children }) {
//   const { user } = useAuth();
//   const STORAGE_KEY = user ? `audio_state_${user.id}` : null;
//   const audioRef = useRef(new Audio());
//   const loadRequestRef = useRef(0);
//   const { addRecent } = useRecent();
//   const [resumeTime, setResumeTime] = useState(0);

//   // Player states
//   const [queue, setQueue] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(-1);
//   const [playing, setPlaying] = useState(false);
//   const [loopOne, setLoopOne] = useState(false);
//   const [shuffle, setShuffle] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);

//   // NEW: States for shuffle order (prevents repeats within one loop)
//   const [shuffleOrder, setShuffleOrder] = useState([]);
//   const [shufflePointer, setShufflePointer] = useState(0);

//   const saveProgress = async (trackId, position, duration) => {
//     if (!user || !trackId) return;
//     if (position < 5) return;

//     await supabase.from("continue_listening").upsert(
//       {
//         user_id: user.id,
//         track_id: trackId,
//         last_position: Math.floor(position),
//         duration: Math.floor(duration || 0),
//         updated_at: new Date(),
//       },
//       {
//         onConflict: "user_id,track_id",
//       },
//     );
//   };

//   const currentTrack =
//     currentIndex >= 0 && currentIndex < queue.length
//       ? queue[currentIndex]
//       : null;

//   // NEW: Fisher-Yates shuffle helper - creates one full order without repeats
//   const buildShuffleOrder = useCallback((tracks, startIndex = 0) => {
//     if (!tracks?.length) return { order: [], pointer: 0 };

//     const indices = tracks.map((_, i) => i);
//     const remaining = indices.filter((i) => i !== startIndex);

//     // Fisher-Yates shuffle
//     for (let i = remaining.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
//     }

//     const order = [startIndex, ...remaining];
//     return { order, pointer: 0 };
//   }, []);

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

//     if (!saved) return;

//     let {
//       queue: savedQueue,
//       currentIndex: savedIndex,
//       currentTime,
//       wasPlaying,
//       loopOne,
//       shuffle,
//       shuffleOrder,
//       shufflePointer,
//     } = saved;

//     if (!savedQueue?.length) return;

//     // Drop leftover YouTube-only tracks and remap the current index.
//     const queue = savedQueue.filter((t) => !isLegacyYoutubeOnly(t));
//     if (!queue.length) return;

//     const removedCount = savedQueue.length - queue.length;
//     let currentIndex = savedIndex;

//     if (removedCount > 0) {
//       const keptBefore = savedQueue
//         .slice(0, Math.max(savedIndex, 0))
//         .filter((t) => !isLegacyYoutubeOnly(t)).length;
//       const currentWasKept =
//         savedQueue[savedIndex] && !isLegacyYoutubeOnly(savedQueue[savedIndex]);

//       currentIndex = Math.min(keptBefore, queue.length - 1);
//       // The saved shuffle order refers to old indices, so reset it.
//       shuffleOrder = [];
//       shufflePointer = 0;
//       if (!currentWasKept) {
//         currentTime = 0;
//         wasPlaying = false;
//       }
//     }

//     setQueue(queue);
//     setCurrentIndex(currentIndex);
//     setLoopOne(loopOne);
//     setShuffle(!!shuffle);
//     setShuffleOrder(shuffleOrder || []);
//     setShufflePointer(shufflePointer || 0);

//     const audio = audioRef.current;

//     setTimeout(() => {
//       const track = queue[currentIndex];
//       if (track) {
//         audio.currentTime = currentTime || 0;

//         if (wasPlaying) {
//           audio.play().catch(() => {});
//           setPlaying(true);
//         }
//       }
//     }, 0);
//   }, [STORAGE_KEY]);

//   useEffect(() => {
//     if (!currentTrack) return;

//     const interval = setInterval(() => {
//       if (!audioRef.current.paused) {
//         saveProgress(
//           currentTrack.id,
//           audioRef.current.currentTime || 0,
//           audioRef.current.duration || 0,
//         );
//       }
//     }, 10000);

//     return () => {
//       clearInterval(interval);

//       if (currentTrack) {
//         saveProgress(
//           currentTrack.id,
//           audioRef.current.currentTime || 0,
//           audioRef.current.duration || 0,
//         );
//       }
//     };
//   }, [currentTrack, user]);

//   // FIXED: setNewQueue now also builds shuffle order if shuffle is on
//   const setNewQueue = useCallback(
//     (tracks, index) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setCurrentIndex(index);

//       if (shuffle) {
//         const { order, pointer } = buildShuffleOrder(tracks, index);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//       } else {
//         setShuffleOrder([]);
//         setShufflePointer(0);
//       }
//     },
//     [shuffle, buildShuffleOrder],
//   );

//   // FIXED: playAll always uses original order, no shuffle
//   const playAll = useCallback((tracks) => {
//     if (!tracks?.length) return;

//     setQueue(tracks);
//     setCurrentIndex(0);
//     setShuffle(false);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//   }, []);

//   const shufflePlay = useCallback(
//     (tracks) => {
//       if (!tracks?.length) return;

//       setQueue(tracks);
//       setShuffle(true);

//       const startIndex = Math.floor(Math.random() * tracks.length);

//       const { order, pointer } = buildShuffleOrder(tracks, startIndex);

//       setShuffleOrder(order);
//       setShufflePointer(pointer);

//       setCurrentIndex(order[pointer]);
//     },
//     [buildShuffleOrder],
//   );

//   const addToQueue = useCallback((track) => {
//     if (!track) return;

//     setQueue((prev) => {
//       if (prev.some((t) => t.id === track.id)) return prev;
//       return [...prev, track];
//     });
//   }, []);

//   const playNextInsert = useCallback(
//     (track) => {
//       if (!track) return;

//       setQueue((prev) => {
//         if (!prev.length) {
//           setCurrentIndex(0);
//           return [track];
//         }

//         const newQueue = [...prev];
//         newQueue.splice(currentIndex + 1, 0, track);
//         return newQueue;
//       });
//     },
//     [currentIndex],
//   );

//   const togglePlay = useCallback(() => {
//     const audio = audioRef.current;
//     if (!audio.src) return;

//     if (audio.paused) {
//       audio.play().then(() => setPlaying(true));
//     } else {
//       audio.pause();
//       setPlaying(false);
//     }
//   }, []);

//   // FIXED: playNext no longer picks random song, uses pre-built shuffle order
//   const playNext = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         // If no shuffle order exists yet, create one
//         if (!shuffleOrder.length) {
//           const { order, pointer } = buildShuffleOrder(
//             queue,
//             current >= 0 ? current : 0,
//           );
//           setShuffleOrder(order);
//           setShufflePointer(pointer);
//           return order[pointer];
//         }

//         const nextPointer = shufflePointer + 1;

//         // If we haven't finished the loop yet, go to next song in shuffle order
//         if (nextPointer < shuffleOrder.length) {
//           setShufflePointer(nextPointer);
//           return shuffleOrder[nextPointer];
//         }

//         // If we finished the loop, create a fresh shuffle order for the next cycle
//         let nextStart = Math.floor(Math.random() * queue.length);

//         // avoid immediate repeat of the just-finished last song
//         const lastPlayed = shuffleOrder[shuffleOrder.length - 1];
//         if (queue.length > 1) {
//           while (nextStart === lastPlayed) {
//             nextStart = Math.floor(Math.random() * queue.length);
//           }
//         }

//         const { order, pointer } = buildShuffleOrder(queue, nextStart);
//         setShuffleOrder(order);
//         setShufflePointer(pointer);
//         return order[pointer];
//       }

//       // Normal mode: go to next, and wrap to 0 at the end
//       if (current + 1 < queue.length) {
//         return current + 1;
//       }

//       return 0;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer, buildShuffleOrder]);

//   // FIXED: playPrev also uses shuffle order when shuffle is on
//   const playPrev = useCallback(() => {
//     if (!queue.length) return;

//     setCurrentIndex((current) => {
//       if (shuffle) {
//         if (!shuffleOrder.length) return current;

//         const prevPointer = shufflePointer - 1;

//         if (prevPointer >= 0) {
//           setShufflePointer(prevPointer);
//           return shuffleOrder[prevPointer];
//         }

//         return shuffleOrder[0];
//       }

//       // Normal mode: go to previous, wrap to last song at beginning
//       return current > 0 ? current - 1 : queue.length - 1;
//     });
//   }, [queue, shuffle, shuffleOrder, shufflePointer]);

//   const reorderQueue = useCallback((newQueue) => {
//     setQueue(newQueue);
//   }, []);

//   const removeFromQueue = useCallback(
//     (trackId) => {
//       setQueue((prev) => {
//         const updated = prev.filter((t) => t.id !== trackId);

//         const removedIndex = prev.findIndex((t) => t.id === trackId);

//         if (removedIndex < currentIndex) {
//           setCurrentIndex((i) => i - 1);
//         }

//         return updated;
//       });
//     },
//     [currentIndex],
//   );

//   // FIXED: clearQueue also clears shuffle states
//   const clearQueue = useCallback(() => {
//     setQueue([]);
//     setCurrentIndex(-1);
//     setShuffleOrder([]);
//     setShufflePointer(0);
//     audioRef.current.pause();
//     audioRef.current.src = "";
//     setPlaying(false);
//   }, []);

//   useEffect(() => {
//     const requestId = ++loadRequestRef.current;
//     let cancelled = false;

//     const isCurrentRequest = () =>
//       !cancelled && loadRequestRef.current === requestId;

//     const loadTrack = async () => {
//       if (!currentTrack) return;

//       const audio = audioRef.current;

//       // Stop the previous native track before loading another one.
//       audio.pause();

//       // Native audio: cache lookup can finish asynchronously.
//       try {
//         const cachedBlob = await getTrack(currentTrack.id);

//         // Never let an older request replace the newly selected track.
//         if (!isCurrentRequest()) return;

//         if (cachedBlob) {
//           audio.src = URL.createObjectURL(cachedBlob);
//         } else {
//           audio.src =
//             currentTrack.external_url ||
//             currentTrack.storage_path ||
//             "";
//         }

//         if (!audio.src) {
//           throw new Error("No playable audio source found.");
//         }

//         audio.load();

//         await audio.play();

//         // The selected track may have changed while play() was pending.
//         if (!isCurrentRequest()) return;

//         setPlaying(true);
//         addRecent(currentTrack);
//         cacheTrack(currentTrack);

//         if (resumeTime > 0) {
//           const timeToResume = resumeTime;
//           setResumeTime(0);

//           // Wait until metadata is available before seeking.
//           if (audio.readyState >= 1) {
//             audio.currentTime = timeToResume;
//           } else {
//             const onMetadata = () => {
//               if (isCurrentRequest()) {
//                 audio.currentTime = Math.min(
//                   timeToResume,
//                   audio.duration || timeToResume,
//                 );
//               }
//             };

//             audio.addEventListener("loadedmetadata", onMetadata, {
//               once: true,
//             });
//           }
//         }

//         saveProgress(currentTrack.id, 0, audio.duration);
//       } catch (err) {
//         if (!isCurrentRequest()) return;
//         if (err.name === "AbortError") return;

//         console.error("Audio playback failed:", err);
//         setPlaying(false);
//       }
//     };

//     loadTrack();

//     return () => {
//       cancelled = true;
//     };
//   }, [currentTrack]);

//   useEffect(() => {
//     const audio = audioRef.current;

//     const onTime = () => {
//       setCurrentTime(audio.currentTime);
//     };

//     const onLoaded = () => setDuration(audio.duration || 0);

//     const onEnded = () => {
//       if (loopOne) {
//         audio.currentTime = 0;
//         audio.play();
//       } else {
//         playNext();
//       }
//     };

//     audio.addEventListener("timeupdate", onTime);
//     audio.addEventListener("loadedmetadata", onLoaded);
//     audio.addEventListener("ended", onEnded);

//     return () => {
//       audio.removeEventListener("timeupdate", onTime);
//       audio.removeEventListener("loadedmetadata", onLoaded);
//       audio.removeEventListener("ended", onEnded);
//     };
//   }, [loopOne, shuffle, playNext]);

//   useEffect(() => {
//     if (!STORAGE_KEY) return;

//     localStorage.setItem(
//       STORAGE_KEY,
//       JSON.stringify({
//         queue,
//         currentIndex,
//         currentTime,
//         wasPlaying: playing,
//         loopOne,
//         shuffle,
//         shuffleOrder,
//         shufflePointer,
//       }),
//     );
//   }, [
//     queue,
//     currentIndex,
//     currentTime,
//     playing,
//     loopOne,
//     shuffle,
//     shuffleOrder,
//     shufflePointer,
//     STORAGE_KEY,
//   ]);

//   const seekTo = (sec) => {
//     const audio = audioRef.current;
//     if (!audio) return;
//     audio.currentTime = Math.max(0, Math.min(sec, audio.duration || 0));
//   };

//   const value = useMemo(
//     () => ({
//       audioRef,
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       setNewQueue,
//       setResumeTime,
//       playAll,
//       shufflePlay,
//       addToQueue,
//       playNextInsert,
//       playNext,
//       playPrev,
//       togglePlay,
//       setLoopOne,
//       setShuffle,
//       seekTo,
//       removeFromQueue,
//       clearQueue,
//       reorderQueue,
//       shuffleOrder,
//       shufflePointer,
//     }),
//     [
//       queue,
//       currentTrack,
//       currentIndex,
//       playing,
//       loopOne,
//       shuffle,
//       currentTime,
//       duration,
//       shuffleOrder,
//       shufflePointer,
//     ],
//   );

//   return (
//     <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
//   );
// }

// export function useAudio() {
//   return useContext(AudioContext);
// }



// 

// progress bar
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import useRecent from "../hooks/useRecent";
import { useAuth } from "./AuthContext";
import { supabase } from "../supabaseClient";
import { cacheWhenBuffered } from "../utils/cacheTrack";
import { getTrack } from "../utils/offlineCache";

const AudioContext = createContext(null);

// Tracks saved from the old YouTube integration have no audio source of
// their own. They can't be played anymore, so they are dropped when a
// saved queue is restored from localStorage.
const isLegacyYoutubeOnly = (t) =>
  !!t?.youtube_video_id && !t?.external_url && !t?.storage_path;

export function AudioProvider({ children }) {
  const { user } = useAuth();
  const STORAGE_KEY = user ? `audio_state_${user.id}` : null;
  const audioRef = useRef(new Audio());
  const loadRequestRef = useRef(0);
  const playNextRef = useRef(() => {});
  const playPrevRef = useRef(() => {});
  const failedSkipsRef = useRef(0);
  const objectUrlRef = useRef(null); // current blob: URL (revoked when replaced)
  const stallTimerRef = useRef(null); // detects a stuck/buffering song
  const retryRef = useRef({ count: 0 }); // recovery attempts for current song
  const isSwitchingRef = useRef(false); // true while changing songs
  const { addRecent } = useRecent();
  const [resumeTime, setResumeTime] = useState(0);

  // Player states
  const [queue, setQueue] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [playing, setPlaying] = useState(false);
  const [loopOne, setLoopOne] = useState(false);
  const [shuffle, setShuffle] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  // NEW: States for shuffle order (prevents repeats within one loop)
  const [shuffleOrder, setShuffleOrder] = useState([]);
  const [shufflePointer, setShufflePointer] = useState(0);

  const saveProgress = async (trackId, position, duration) => {
    if (!user || !trackId) return;
    if (position < 5) return;

    await supabase.from("continue_listening").upsert(
      {
        user_id: user.id,
        track_id: trackId,
        last_position: Math.floor(position),
        duration: Math.floor(duration || 0),
        updated_at: new Date(),
      },
      {
        onConflict: "user_id,track_id",
      },
    );
  };

  const currentTrack =
    currentIndex >= 0 && currentIndex < queue.length
      ? queue[currentIndex]
      : null;

  // NEW: Fisher-Yates shuffle helper - creates one full order without repeats
  const buildShuffleOrder = useCallback((tracks, startIndex = 0) => {
    if (!tracks?.length) return { order: [], pointer: 0 };

    const indices = tracks.map((_, i) => i);
    const remaining = indices.filter((i) => i !== startIndex);

    // Fisher-Yates shuffle
    for (let i = remaining.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [remaining[i], remaining[j]] = [remaining[j], remaining[i]];
    }

    const order = [startIndex, ...remaining];
    return { order, pointer: 0 };
  }, []);

  useEffect(() => {
    if (!STORAGE_KEY) return;

    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

    if (!saved) return;

    let {
      queue: savedQueue,
      currentIndex: savedIndex,
      currentTime,
      wasPlaying,
      loopOne,
      shuffle,
      shuffleOrder,
      shufflePointer,
    } = saved;

    if (!savedQueue?.length) return;

    // Drop leftover YouTube-only tracks and remap the current index.
    const queue = savedQueue.filter((t) => !isLegacyYoutubeOnly(t));
    if (!queue.length) return;

    const removedCount = savedQueue.length - queue.length;
    let currentIndex = savedIndex;

    if (removedCount > 0) {
      const keptBefore = savedQueue
        .slice(0, Math.max(savedIndex, 0))
        .filter((t) => !isLegacyYoutubeOnly(t)).length;
      const currentWasKept =
        savedQueue[savedIndex] && !isLegacyYoutubeOnly(savedQueue[savedIndex]);

      currentIndex = Math.min(keptBefore, queue.length - 1);
      // The saved shuffle order refers to old indices, so reset it.
      shuffleOrder = [];
      shufflePointer = 0;
      if (!currentWasKept) {
        currentTime = 0;
        wasPlaying = false;
      }
    }

    setQueue(queue);
    setCurrentIndex(currentIndex);
    setLoopOne(loopOne);
    setShuffle(!!shuffle);
    setShuffleOrder(shuffleOrder || []);
    setShufflePointer(shufflePointer || 0);

    const audio = audioRef.current;

    setTimeout(() => {
      const track = queue[currentIndex];
      if (track) {
        audio.currentTime = currentTime || 0;

        if (wasPlaying) {
          audio.play().catch(() => {});
          setPlaying(true);
        }
      }
    }, 0);
  }, [STORAGE_KEY]);

  useEffect(() => {
    if (!currentTrack) return;

    const interval = setInterval(() => {
      if (!audioRef.current.paused) {
        saveProgress(
          currentTrack.id,
          audioRef.current.currentTime || 0,
          audioRef.current.duration || 0,
        );
      }
    }, 10000);

    return () => {
      clearInterval(interval);

      if (currentTrack) {
        saveProgress(
          currentTrack.id,
          audioRef.current.currentTime || 0,
          audioRef.current.duration || 0,
        );
      }
    };
  }, [currentTrack, user]);

  // FIXED: setNewQueue now also builds shuffle order if shuffle is on
  const setNewQueue = useCallback(
    (tracks, index) => {
      if (!tracks?.length) return;

      setQueue(tracks);
      setCurrentIndex(index);

      if (shuffle) {
        const { order, pointer } = buildShuffleOrder(tracks, index);
        setShuffleOrder(order);
        setShufflePointer(pointer);
      } else {
        setShuffleOrder([]);
        setShufflePointer(0);
      }
    },
    [shuffle, buildShuffleOrder],
  );

  // FIXED: playAll always uses original order, no shuffle
  const playAll = useCallback((tracks) => {
    if (!tracks?.length) return;

    setQueue(tracks);
    setCurrentIndex(0);
    setShuffle(false);
    setShuffleOrder([]);
    setShufflePointer(0);
  }, []);

  const shufflePlay = useCallback(
    (tracks) => {
      if (!tracks?.length) return;

      setQueue(tracks);
      setShuffle(true);

      const startIndex = Math.floor(Math.random() * tracks.length);

      const { order, pointer } = buildShuffleOrder(tracks, startIndex);

      setShuffleOrder(order);
      setShufflePointer(pointer);

      setCurrentIndex(order[pointer]);
    },
    [buildShuffleOrder],
  );

  const addToQueue = useCallback((track) => {
    if (!track) return;

    setQueue((prev) => {
      if (prev.some((t) => t.id === track.id)) return prev;
      return [...prev, track];
    });
  }, []);

  const playNextInsert = useCallback(
    (track) => {
      if (!track) return;

      setQueue((prev) => {
        if (!prev.length) {
          setCurrentIndex(0);
          return [track];
        }

        const newQueue = [...prev];
        newQueue.splice(currentIndex + 1, 0, track);
        return newQueue;
      });
    },
    [currentIndex],
  );

  const togglePlay = useCallback(() => {
    const audio = audioRef.current;
    if (!audio.src) return;

    if (audio.paused) {
      audio.play().then(() => setPlaying(true));
    } else {
      audio.pause();
      setPlaying(false);
    }
  }, []);

  // FIXED: playNext no longer picks random song, uses pre-built shuffle order
  const playNext = useCallback(() => {
    if (!queue.length) return;

    setCurrentIndex((current) => {
      if (shuffle) {
        // If no shuffle order exists yet, create one
        if (!shuffleOrder.length) {
          const { order, pointer } = buildShuffleOrder(
            queue,
            current >= 0 ? current : 0,
          );
          setShuffleOrder(order);
          setShufflePointer(pointer);
          return order[pointer];
        }

        const nextPointer = shufflePointer + 1;

        // If we haven't finished the loop yet, go to next song in shuffle order
        if (nextPointer < shuffleOrder.length) {
          setShufflePointer(nextPointer);
          return shuffleOrder[nextPointer];
        }

        // If we finished the loop, create a fresh shuffle order for the next cycle
        let nextStart = Math.floor(Math.random() * queue.length);

        // avoid immediate repeat of the just-finished last song
        const lastPlayed = shuffleOrder[shuffleOrder.length - 1];
        if (queue.length > 1) {
          while (nextStart === lastPlayed) {
            nextStart = Math.floor(Math.random() * queue.length);
          }
        }

        const { order, pointer } = buildShuffleOrder(queue, nextStart);
        setShuffleOrder(order);
        setShufflePointer(pointer);
        return order[pointer];
      }

      // Normal mode: go to next, and wrap to 0 at the end
      if (current + 1 < queue.length) {
        return current + 1;
      }

      return 0;
    });
  }, [queue, shuffle, shuffleOrder, shufflePointer, buildShuffleOrder]);

  // Keep a ref to the latest playNext so the load effect can skip a broken track.
  useEffect(() => {
    playNextRef.current = playNext;
  }, [playNext]);

  // FIXED: playPrev also uses shuffle order when shuffle is on
  const playPrev = useCallback(() => {
    if (!queue.length) return;

    setCurrentIndex((current) => {
      if (shuffle) {
        if (!shuffleOrder.length) return current;

        const prevPointer = shufflePointer - 1;

        if (prevPointer >= 0) {
          setShufflePointer(prevPointer);
          return shuffleOrder[prevPointer];
        }

        return shuffleOrder[0];
      }

      // Normal mode: go to previous, wrap to last song at beginning
      return current > 0 ? current - 1 : queue.length - 1;
    });
  }, [queue, shuffle, shuffleOrder, shufflePointer]);

  useEffect(() => {
    playPrevRef.current = playPrev;
  }, [playPrev]);

  const reorderQueue = useCallback((newQueue) => {
    setQueue(newQueue);
  }, []);

  const removeFromQueue = useCallback(
    (trackId) => {
      setQueue((prev) => {
        const updated = prev.filter((t) => t.id !== trackId);

        const removedIndex = prev.findIndex((t) => t.id === trackId);

        if (removedIndex < currentIndex) {
          setCurrentIndex((i) => i - 1);
        }

        return updated;
      });
    },
    [currentIndex],
  );

  // FIXED: clearQueue also clears shuffle states
  const clearQueue = useCallback(() => {
    setQueue([]);
    setCurrentIndex(-1);
    setShuffleOrder([]);
    setShufflePointer(0);
    audioRef.current.pause();
    audioRef.current.src = "";
    setPlaying(false);
  }, []);

  // ---------------------------------------------------------------------
  // LOAD + PLAY the selected song
  // ---------------------------------------------------------------------
  useEffect(() => {
    const requestId = ++loadRequestRef.current;
    let cancelled = false;
    const cacheAbort = new AbortController();

    const isCurrentRequest = () =>
      !cancelled && loadRequestRef.current === requestId;

    clearTimeout(stallTimerRef.current);
    retryRef.current = { count: 0 };

    const loadTrack = async () => {
      if (!currentTrack) return;

      const audio = audioRef.current;

      isSwitchingRef.current = true;
      audio.pause();

      try {
        // 1) Offline copy if we have one. A broken IndexedDB must NOT stop
        //    streaming, so errors here just fall through to the network URL.
        let src = "";
        try {
          const cachedBlob = await getTrack(currentTrack.id);
          if (!isCurrentRequest()) return;
          if (cachedBlob) src = URL.createObjectURL(cachedBlob);
        } catch (e) {
          console.warn("Offline lookup failed, streaming instead:", e);
        }

        // 2) Otherwise stream.
        if (!src) {
          src = currentTrack.external_url || currentTrack.storage_path || "";
        }
        if (!src) throw new Error("No playable audio source found.");

        const previousUrl = objectUrlRef.current;
        objectUrlRef.current = src.startsWith("blob:") ? src : null;

        audio.preload = "auto";
        audio.src = src;

        // Free the previous blob URL (it was leaking before).
        if (previousUrl) URL.revokeObjectURL(previousUrl);

        await audio.play();

        if (!isCurrentRequest()) return;

        isSwitchingRef.current = false;
        failedSkipsRef.current = 0;
        setPlaying(true);
        addRecent(currentTrack);

        // Cache for offline ONLY after the song is fully buffered, one at a
        // time, and cancel if the user changes song. Never competes with
        // streaming.
        if (!objectUrlRef.current) {
          cacheWhenBuffered(currentTrack, audio, cacheAbort.signal);
        }

        if (resumeTime > 0) {
          const timeToResume = resumeTime;
          setResumeTime(0);

          if (audio.readyState >= 1) {
            audio.currentTime = timeToResume;
          } else {
            audio.addEventListener(
              "loadedmetadata",
              () => {
                if (isCurrentRequest()) {
                  audio.currentTime = Math.min(
                    timeToResume,
                    audio.duration || timeToResume,
                  );
                }
              },
              { once: true },
            );
          }
        }

        saveProgress(currentTrack.id, 0, audio.duration);
      } catch (err) {
        if (!isCurrentRequest()) return;
        if (err.name === "AbortError") return;

        console.error("Audio playback failed:", err.name, err.message);
        isSwitchingRef.current = false;

        // Browser blocked play() (no user gesture / background). The song is
        // loaded, so just wait for the user to press play. Do not skip.
        if (err.name === "NotAllowedError") {
          setPlaying(false);
          return;
        }

        // Broken song: move on, but never loop more times than there are songs.
        if (failedSkipsRef.current < queue.length - 1) {
          failedSkipsRef.current += 1;
          playNextRef.current();
        } else {
          setPlaying(false);
        }
      }
    };

    loadTrack();

    return () => {
      cancelled = true;
      cacheAbort.abort(); // stop background caching of the previous song
    };
  }, [currentTrack]);

  // ---------------------------------------------------------------------
  // AUDIO ELEMENT EVENTS (progress, ended, stall/error recovery)
  // ---------------------------------------------------------------------
  useEffect(() => {
    const audio = audioRef.current;

    const clearStall = () => clearTimeout(stallTimerRef.current);

    // Try to revive a stuck/errored stream twice, then skip to next song.
    const recover = () => {
      if (!audio.getAttribute("src")) return;

      if (retryRef.current.count < 2) {
        retryRef.current.count += 1;
        const resumeAt = audio.currentTime || 0;

        audio.load();
        audio.addEventListener(
          "loadedmetadata",
          () => {
            if (resumeAt > 0) audio.currentTime = resumeAt;
            audio.play().catch(() => {});
          },
          { once: true },
        );
      } else if (failedSkipsRef.current < queue.length - 1) {
        failedSkipsRef.current += 1;
        playNextRef.current();
      } else {
        setPlaying(false);
      }
    };

    const onTime = () => {
      setCurrentTime(audio.currentTime);
      clearStall();
    };

    const onLoaded = () => setDuration(audio.duration || 0);

    const onPlaying = () => {
      isSwitchingRef.current = false;
      clearStall();
      setPlaying(true);
    };

    // Keeps UI correct when paused from lock screen / headset / notification.
    const onPause = () => {
      if (!isSwitchingRef.current && !audio.ended) setPlaying(false);
    };

    // Network hiccup: if nothing moves for 10s, kick the stream.
    const onWaiting = () => {
      clearStall();
      stallTimerRef.current = setTimeout(recover, 10000);
    };

    const onError = () => {
      clearStall();
      recover();
    };

    const onEnded = () => {
      if (loopOne || queue.length === 1) {
        // (a one-song queue never changes currentIndex, so restart it here)
        audio.currentTime = 0;
        audio.play().catch(() => {});
      } else {
        playNext();
      }
    };

    audio.addEventListener("timeupdate", onTime);
    audio.addEventListener("loadedmetadata", onLoaded);
    audio.addEventListener("playing", onPlaying);
    audio.addEventListener("pause", onPause);
    audio.addEventListener("waiting", onWaiting);
    audio.addEventListener("stalled", onWaiting);
    audio.addEventListener("error", onError);
    audio.addEventListener("ended", onEnded);

    return () => {
      clearStall();
      audio.removeEventListener("timeupdate", onTime);
      audio.removeEventListener("loadedmetadata", onLoaded);
      audio.removeEventListener("playing", onPlaying);
      audio.removeEventListener("pause", onPause);
      audio.removeEventListener("waiting", onWaiting);
      audio.removeEventListener("stalled", onWaiting);
      audio.removeEventListener("error", onError);
      audio.removeEventListener("ended", onEnded);
    };
  }, [loopOne, shuffle, playNext, queue.length]);

  // Coming back from lock screen / another app: resume if we should be playing.
  useEffect(() => {
    const onVisible = () => {
      const audio = audioRef.current;
      if (
        document.visibilityState === "visible" &&
        playing &&
        audio.paused &&
        !audio.ended &&
        audio.getAttribute("src")
      ) {
        audio.play().catch(() => {});
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [playing]);

  // ---------------------------------------------------------------------
  // MEDIA SESSION: lock-screen / notification controls (what Spotify and
  // JioSaavn use). Also marks this page as an active media player so
  // Android/iOS keep it alive when the screen is off.
  // ---------------------------------------------------------------------
  useEffect(() => {
    if (!("mediaSession" in navigator) || !currentTrack) return;

    navigator.mediaSession.metadata = new MediaMetadata({
      title: currentTrack.title || "",
      artist: currentTrack.artist || "",
      album: "Myraagam",
      artwork: currentTrack.cover_url
        ? [{ src: currentTrack.cover_url, sizes: "512x512" }]
        : [],
    });
  }, [currentTrack]);

  useEffect(() => {
    if (!("mediaSession" in navigator)) return;
    navigator.mediaSession.playbackState = playing ? "playing" : "paused";
  }, [playing]);

  useEffect(() => {
    if (!("mediaSession" in navigator)) return;
    const audio = audioRef.current;
    const ms = navigator.mediaSession;
    const set = (name, fn) => {
      try {
        ms.setActionHandler(name, fn);
      } catch {}
    };

    set("play", () => audio.play().catch(() => {}));
    set("pause", () => audio.pause());
    set("nexttrack", () => playNextRef.current());
    set("previoustrack", () => playPrevRef.current());
    set("seekto", (d) => {
      if (d.seekTime != null) audio.currentTime = d.seekTime;
    });

    return () => {
      ["play", "pause", "nexttrack", "previoustrack", "seekto"].forEach((a) =>
        set(a, null),
      );
    };
  }, []);

  useEffect(() => {
    if (!STORAGE_KEY) return;

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        queue,
        currentIndex,
        currentTime,
        wasPlaying: playing,
        loopOne,
        shuffle,
        shuffleOrder,
        shufflePointer,
      }),
    );
  }, [
    queue,
    currentIndex,
    currentTime,
    playing,
    loopOne,
    shuffle,
    shuffleOrder,
    shufflePointer,
    STORAGE_KEY,
  ]);

  const seekTo = (sec) => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.currentTime = Math.max(0, Math.min(sec, audio.duration || 0));
  };

  const value = useMemo(
    () => ({
      audioRef,
      queue,
      currentTrack,
      currentIndex,
      playing,
      loopOne,
      shuffle,
      currentTime,
      duration,
      setNewQueue,
      setResumeTime,
      playAll,
      shufflePlay,
      addToQueue,
      playNextInsert,
      playNext,
      playPrev,
      togglePlay,
      setLoopOne,
      setShuffle,
      seekTo,
      removeFromQueue,
      clearQueue,
      reorderQueue,
      shuffleOrder,
      shufflePointer,
    }),
    [
      queue,
      currentTrack,
      currentIndex,
      playing,
      loopOne,
      shuffle,
      currentTime,
      duration,
      shuffleOrder,
      shufflePointer,
    ],
  );

  return (
    <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
  );
}

export function useAudio() {
  return useContext(AudioContext);
}